/**
 * Created by Miguel on 23/05/2017
 */
import { Component, HostListener,OnInit,Input, ViewChild,ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { EventBean } from '../../beansts/Event';
import { CompanyService }  from '../../services/company.service';
import { AppDataService }  from '../../services/app-data.service';
import {WritBean} from "../../beansts/quests/writ.bean";
import {CompanyBean} from "../../beansts/company.bean";
import {RecipeBean} from "../../beansts/recipe.bean";
import {ItemBean} from "../../beansts/item.bean";
import {WalletService} from '../../services/wallet.services';

import { MessagingService } from "../../messaging.service";
import {Router} from "@angular/router";
import {TranslationService} from '../../services/translation.service';
import { Door } from '../../beansts/itens/door.bean';
import {FormBuilder, FormGroup} from "@angular/forms";


//teleview
declare var Swal : any;
declare var $ : any;
declare var google : any;

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'event',
    templateUrl:'gameevent.component.html',
    providers  : []
})
export class EventComponent  implements OnInit {
  public lastChangeTime=0;
  public backgroundPhotoForm: FormGroup;
  public background2dForm: FormGroup;

  @Input() myRoom: string;
  public entryPhoto='/assets/cell/388104.jpg'
  public entryText='Loading...';
  public entryIcon='/assets/favicon/android-icon-144x144.png';
  public entryInterval;

  public isIOS=false;

    public event: EventBean=new EventBean();
    public mobile = false;
    public tdswitch=false;
    public muted;

    public isMap=false
    public searchForm : FormGroup;
    public mapSession;

    public door;
    public iframeVolume;
    public queryRoom=null;
    public shouldRunAndroid

    public videoBackground="";
    public appEvent
    public appSpeaker;
    public user={uid:'n/a',full_name:'Anonimo',profile_picture:'nil'};
    public userOnView;
    public openContact=false;
    public chatId;
    public loginTab=false;
    public tables=[];
    public notification;
    public hasTele=false;
    public mytable={};
    public countdown='';
    public webGl=false;

    public menuConfig;
    public zoomControl=0;

    public message;

    public conference=true;
    public loadingConference=false;
    public hasCamera=true;
    public bigConference=false;
    public bigStream=false;
    public videoCall='';

    public admin= false;
    public video='DESLIGAR VIDEO'

    public changed=null;
    public loveList=[];
    public userList=[];



    public nameTable=true;
    public chooseFriends=false;

    public language="pt"
    public notificationsON=false;
    public tab=1;
    public canLove=false;

    public companyEvents:EventBean [];
    public company
    public videoWorker

/////////////////feeds
    public eventNotificationFeed;
    public worker;
    public locationWorker;
    public roomNotificationFeed;
    public userPositions;
    public itensOnRoomFeed;
    public partyMembersRef;
    constructor( public _sanitizer: DomSanitizer,public translate: TranslationService,public _router : Router,public _routeParams : ActivatedRoute,public _companyService : CompanyService,public _walletService : WalletService, public _appData : AppDataService,public msgService: MessagingService,public fb : FormBuilder) {

    }
    public ngOnDestroy() {

    }
    public organizeStyle(): void {
      $("#main").css("padding-bottom", "0px");
      $("#main").css("background-color","#242424");
    }
    public openContacts(){
      $('#jitsi-control-tutorial').click();
      if (isNaN(this._appData.instagramUser.uid)){
        let idx=$("#profileModal")
        this._appData.tiping=true;
        idx.modal('show');
      }
      else{
        $('#registerSocialModal').modal('show')
        this._appData.tiping=true;

      }
    }

    public keyBoardOn(){
      this.sendIframeMessage({kind:'panCamera'})
    }
    public doSearch(){
      let query : string      = this.searchForm.controls['search'].value;
      let self=this
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode( { 'address': query}, function(results, status) {

            if (status == google.maps.GeocoderStatus.OK) {
                var latitude = results[0].geometry.location.lat();
                var longitude = results[0].geometry.location.lng();
                self._companyService.getPanoIds(latitude,longitude).subscribe(v=>{
                  let body=v['_body'];
                  let bb=JSON.parse(body);
                  let pano=bb.panoIds[0]
                  self.sendIframeMessage({
                    kind:'gotoPano',
                    params:{uid:self._appData.instagramUser.uid,panoId:pano}
                  });

                })
            }

        });
    }


    public addItem(){
      this._appData.object=new ItemBean();
    $("#itemManipulationModal").modal('show')
    $("#itemManipulationReload").click()
    }

    public openChat(contact){
      if (this._appData.instagramUser){
        this._appData.toggleCellPhone=!this._appData.toggleCellPhone;
        this._appData.tiping=true;
        this._appData.talkTo=contact;
        this._appData.cellScreen='chat'

        setTimeout(()=>{
          $('#cellChatReload').click()
        },1000)

      }
      else{
        $('#registerSocialModal').modal('show');
        this._appData.tiping=true;
      }

    }

    public gotoContacts(){
      if (this._appData.instagramUser){
        this._appData.toggleCellPhone=!this._appData.toggleCellPhone;
        this._appData.tiping=true;
        this._appData.cellScreen='usuariosNaSala'

        setTimeout(()=>{
          $('#cellChatReload').click()
        },1000)

      }
      else{
        $('#registerSocialModal').modal('show');
        this._appData.tiping=true;
      }

    }
    public goto (contact){
      if (this._appData.instagramUser){
        Swal.fire({
          title: this.translate.instant('CONTACT_SCREEN_COMPONENT_14'),
          text:this.translate.instant('CONTACT_SCREEN_COMPONENT_15a'),
          confirmButtonText: this.translate.instant('YES'),
          cancelButtonText:this.translate.instant('NO'),
          showCancelButton: true,
          showCloseButton: true,
        }).then((result) => {
          if (result.value) {
            this.sendIframeMessage({
              kind:'updateUserStatus',
              params:{uid:this._appData.instagramUser.uid,state:'stop',location:{x:contact.position.x,y:contact.position.y}}
            });

          }
        });
      }
      else{
        $('#registerSocialModal').modal('show');
        this._appData.tiping=true;
      }
    }
    public seeProfile(contact){
      this._appData.friendOnEvent=contact
      $('#userInteractionModal').modal('show');
      $('#userInteractionModalClick').click();
    }
        public handleOrientation(event: DeviceOrientationEvent) {
         // console.log("Orientation data:", event.alpha, event.beta, event.gamma);
        }
    public garanteeFullScreen(){

      const currentPath = window.location.pathname;
      if (currentPath.indexOf('social')>=0){return;}
      if (window){
        this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
        var ua = navigator.userAgent.toLowerCase();
        var isAndroid = ((ua.indexOf("android") > -1)) //|| (ua.indexOf("mobile")>-1));
        this._appData.android=isAndroid;
        if(isAndroid || this.isIOS) {
          if ('orientation' in screen && 'lock' in screen.orientation && !isAndroid) {
            (screen.orientation as any).lock('landscape').catch(function(error: any) {
              if (screen.orientation.angle==0){
                Swal.fire({title:'Orientação incorreta',text:'Esse app fica muito melhor com a tela de lado. Sugerimos que você entre novamente com o celular na horizonta.'}).then((result) => {
                  self.controlEnteringModal()
                })
              }
                console.log('Orientation lock failed:', error);
            });
          } else {
              console.log('Orientation lock not supported on this device.');
          }
          let self=this
        // @ts-ignore to avoid TS error if you know the property exists
        if (typeof (DeviceMotionEvent as any).requestPermission === 'function') {
          // iOS-specific permission request
          (DeviceMotionEvent as any).requestPermission()
            .then((response: string) => {
              if (response === 'granted') {
                console.log("Motion permission granted");
                window.addEventListener('deviceorientation', this.handleOrientation);
              } else {
                console.warn("Motion permission denied");
              }
            })
            .catch(console.error);
        } else {
          // Android or desktop — no permission needed
          window.addEventListener('deviceorientation', this.handleOrientation);
        }
      


          Swal.fire({
            title:this.translate.instant('EVENT_COMPONENT_0'),
            text:this.translate.instant('EVENT_COMPONENT_1'),
            confirmButtonText: 'OK',
            focusConfirm: false,
            }).then((result) => {
              var element = document.documentElement as HTMLElement & {
                mozRequestFullScreen(): Promise<void>;
                webkitRequestFullscreen(): Promise<void>;
                msRequestFullscreen(): Promise<void>;
              };// Get the root element of the document

              if (element.requestFullscreen) {
                element.requestFullscreen(); // Standard syntax
              } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen(); // Firefox
              } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen(); // Chrome, Safari, and Opera
              } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen(); // Internet Explorer and Edge
              }


            })
        }


    }

    }

    public ngOnInit()  {
      let self=this;

      window.addEventListener('angularMessage', (event : any)=>{
        if (event.detail && event.detail.kind=='reloadRoom'){
            this.sendIframeMessage({kind:'restartRoom',param:{room:event.detail.room}})
        }
      })
      window.addEventListener(
          "androidMessage",
          (event:any)=>{

              const message = event.detail;

              switch(message.kind){

                  case "setRoom":
                      console.log('RECEBI MENSAGEM DO ANDROID')
                      this.sendIframeMessage({

                          kind:"setRoom",

                          room:message.room

                      });

                      break;

              }

          }
      );      

      window.addEventListener('roomReady', (event : any)=>{
          this.controlEnteringModal();

            setTimeout(()=>{

                       this.getUserPositions();

            },10000);

       });
      window.addEventListener('characterDone', (event : any)=>{

              clearInterval(this.entryInterval)
              $('#entryPhoto').remove();
              //$('#iframeModal').remove();


      });


    
      let company=new CompanyBean();
      this._appData.event=new EventBean();
      this._appData.event.company=company;
      this.background2dForm = this.fb.group({
        x : 0,
        y: 0
      });
      this.searchForm = this.fb.group({
        search : '',
      });
      let user=null;
      if (typeof window !== "undefined" && localStorage) {
        user=localStorage.getItem('instagramUser');


      }
      if (user=="undefined"){
        user=null;
      }
      if (user){
        this._appData.instagramUser=JSON.parse(user);
      }
      this._companyService.getAuth().onAuthStateChanged(
        user => {
          if (user) {
            // User is signed in.
            console.log(user)
          } else {
            // No user is signed in.
//            $('#registerSocialModal').modal('show')
  //          this._appData.tiping=true;
          }
        },
        // Prevent console error
        error => {
    //      $('#registerSocialModal').modal('show')
      //    this._appData.tiping=true;
        }
      );
      if (this._appData.instagramUser){
        if (!this._appData.instagramUser.token){
          this.msgService.getPermission()
          this.msgService.receiveMessage()
          this.message = this.msgService.currentMessage
        }
        else{
          this.msgService.receiveMessage()
        }
        this.organizeStyle();
         //update user for vippoints
        this._companyService.getUserByUid(this._appData.instagramUser.uid).then((val)=>{
          let us=val.data();
          if (us){
            this._appData.instagramUser=us;
            if (localStorage) {localStorage.setItem('instagramUser',JSON.stringify(this._appData.instagramUser))}
          }
        });

      }
      this.garanteeFullScreen();

      this.initWorld()


      navigator.mediaDevices.enumerateDevices()
      .then(devices => {
        // Check the connected devices
        console.log(devices);
      });
      document.onkeydown=function (e) {
        let ev = e || window.event;							 
        self.sendIframeMessage({kind:'keyAction',key:e.keyCode})

      }

    

    

    }
    public openEmojis(){
      this._appData.muted=this.muted
      $('#emojisModal').modal('show')
    }
    public zoom(inout){



      if (inout){
  //      if (this.zoomControl<20){
          this.zoomControl=this.zoomControl+1;
          this.sendIframeMessage({kind:'zoomout'})
          $("#btnZoomIn").attr("src", "./assets/game-ui/desk/g6501.png");
          setTimeout(()=>{
            $("#btnZoomIn").attr("src", "./assets/game-ui/desk/g4421.png");
          },1000);
    //    }
      }
      else{
      //  if (this.zoomControl>-8){
          this.zoomControl=this.zoomControl-1;
          this.sendIframeMessage({kind:'zoomin'})
          $("#btnZoomOut").attr("src", "./assets/game-ui/desk/g6631.png");
          setTimeout(()=>{
            $("#btnZoomOut").attr("src", "./assets/game-ui/desk/g4415.png");
          },1000);

        //}


      }
    }
    public gotoReception(){
      if (this._appData.room.reception){
        Swal.fire({title:this.translate.instant('EVENT_COMPONENT_2'),
        text:this.translate.instant('EVENT_COMPONENT_3'),
        confirmButtonText: this.translate.instant('YES'),
        cancelButtonText:this.translate.instant('NO'),
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        }).then((result) => {
          if (result.dismiss=='backdrop') {}
          else if (result.dismiss=='close') {}
          else if (result.dismiss=='cancel'){}
          else{
        let domain=window.location.origin
        window.location.href=domain+"/meeting/"+this._appData.event.id+'?room='+this._appData.room.reception;
          }});

      }
      else{
        Swal.fire({title:this.translate.instant('EVENT_COMPONENT_2'),
        text:this.translate.instant('EVENT_COMPONENT_4'),
        confirmButtonText: this.translate.instant('YES'),
        cancelButtonText:this.translate.instant('NO'),
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        }).then((result) => {
          if (result.dismiss=='backdrop') {}
          else if (result.dismiss=='close') {}
          else if (result.dismiss=='cancel'){}
          else{
            let domain=window.location.origin
            window.location.href=domain+"/welcome?event="+this._appData.event.id+'&room='+this._appData.room.id;
          }});

      }
    }

    public menuOpen=true;
    public toggleMenu(){
      $('#menu-toggle').click();
      let doc=document.getElementById('sidebar');
      
      let myclass=doc.className
      if (myclass.indexOf('active')>0){
        this.menuOpen=false;
      }
      else{
        this.menuOpen=true
      }
    }
    public gotoCell(){
      if (this._appData.instagramUser){
        this._appData.toggleCellPhone=!this._appData.toggleCellPhone;
        this._appData.tiping=true;
      }
      else{
        $('#registerSocialModal').modal('show');
        this._appData.tiping=true;
      }

    }

    public initWorld(){
      if (this._appData.instagramUser){
        this.translate.setDefaultLang(this._appData.instagramUser.lang)
      }
      this.language=this.translate.getDefaultLanguage()
      //The event detail can either open from the params or come from appData event. Its quicker to come from appdata.event because i already have the data on memory.
      //cria valores inicias pra mandar o usuario pro mundo principal
            this.event=new EventBean();
            this.company=new CompanyBean();
            this.company.viplistasHide=false;
            this.event.company=this.company;
            this.event.id=1592880902713;
            this.event.room='1644803653158';
            this.event.name="LIVEPLANET"
            this.event.avatarVersion=3;
            this.event.description="Sua presenca online em eventos"
            this.event.shortDescription="O evento está sendo coletado do nosso banco de dados...aguarde alguns segundos e estará visível para entrar na lista"
            this.event.thumbnail="/assets/loadingmovie.gif"
            this.event.icon="/assets/loadingmovie.gif"
            this.event.date="coletando data e hora do evento..."
            this.event.attractions="coletando as atrações do evento..."
            this.event.benefits="coletando os benefícios do evento..."
            this._appData.event=this.event;
              //pego os parametros de query
            this._routeParams.queryParams.subscribe(params => {
              var uid = params['uid'];
              //option for auto-register
              var code=params['code']
              this.queryRoom=params['room']
              this.shouldRunAndroid=params['runAndroid']
              if (!this.queryRoom){
                this.queryRoom=this.myRoom//'1752341543384'//'1626799638931'
              }
              this.appEvent=params['evt']
              this.appSpeaker=params['speaker']
              let queryEvent=params['event']

              let lat=params['lat']
              let lng=params['lng']
              let vr=params['vr']
              let photo=params['photo']
              if (vr){
                this._appData.vr=true;
              }
              if (photo){
                this._appData.photo=true;
              }

              if (lat){
                this._appData.latLng={lat:Number(lat),lng:Number(lng)}
              }
              /*if (code){
                //COLETA E REGISTRO DE USUARIO VINDO DE FORA POR CODIGO EXTERNO
                this.registerUser(code);
              }
              else{*/
                if (uid){
                  //COLETA DE USUARIO USANDO O UID VINDO DE FORA
                  this._companyService.getUserByUid(uid).then(val=>{
                    this._appData.instagramUser=val.data();
                    if (typeof window !== "undefined" && localStorage){
                      localStorage.setItem('instagramUser',JSON.stringify(val.data()))
                    }

                    if (this.shouldRunAndroid){
                      this.event=new EventBean();
                      this.event.id=1592880902713
                      this.fillEventData(this.event);
                      console.log('run from localserver')
                      return;
                    }
                  //Vai atras de detalhes do evento
                        if (queryEvent){
                          this.getEventParam(queryEvent);
                        }
                        else{
                          this._companyService.getEventById(this.event.id).subscribe(
                            (_event: any) => {
                                var obj = _event;
                                if (obj.url){
                                  obj=_event.json();
                                }
                                if (obj.length>0){
                                  this.event=obj[0]
                                }
                                else{
                                  this.event=obj;
                                }
                                let myevent:EventBean = this.event;
                                this._appData.event=myevent;
                                if (myevent){
                                  this.fillEventData(myevent);
                                }
                            });
                        }
                  })
                }
                else{
                    if (this.shouldRunAndroid){
                      this.event=new EventBean();
                      this.event.id=1592880902713
                      this.fillEventData(this.event);
                      console.log('run from localserver')
                      return;
                    }
                  //USUARIO NAO INFORMADO...VER SE USUARIO TA NA MEMORIA DO BROWSER ou SE USUARIO DESLOGADO
              //define room to be
                        if (queryEvent){
                          this.getEventParam(queryEvent);
                        }
                        else{
                          this._companyService.getEventById(this.event.id).subscribe(
                            (_event: any) => {
                                var obj = _event;
                                if (obj.url){
                                  obj=_event.json();
                                }
                                if (obj.length>0){
                                  this.event=obj[0]
                                }
                                else{
                                  this.event=obj;
                                }
                                let myevent:EventBean = this.event;
                                this._appData.event=myevent;
                                if (myevent){
                                  this.fillEventData(myevent);
                                }
                            });
                        }


                }
  //            }
            });

    }
    //STATIC METHOD SEE IMPLEMENTATION ON CHILDREN
    public processRoomMenu(){}

    public getRoomFromParam(){
      let roomToBe=this.queryRoom;
      if (this.shouldRunAndroid){//rodando localmente
        this._companyService.getLocalRoom(roomToBe).then(response=>{
          response.json().then(room=>{
            room.localRoom=true;
            console.log('PROCESSADO PRO LOCALSERVER')
            this._appData.room=room;
            this._companyService.getLocalCompany(room.company).then(response2=>{
              response2.json().then(company=>{
                this._appData.room.npcs=company.npcs;
                this._appData.room.writs=company.writs;
                this._appData.activeWrits={};
                this._appData.room.writs.forEach(w=>{
                  this._appData.activeWrits[w.group]=w
                })
                this.completeRoomProcess();
              })
            })

          })
        })
        console.log('VOU RODAR DO ANDROID')
        return;
      }
      if (!roomToBe) {
        if (this._appData.instagramUser){
          roomToBe=this._appData.instagramUser.room
        }
        if (!roomToBe){
          roomToBe=this.event.room;
        }
      }
      if (roomToBe.indexOf('noroom')==0){
        if (roomToBe.length>6){
          this._appData.room={id:roomToBe,name:'sem nome',textures:{meetingBackground:''},father:'1644803653158'}
        }
        else{
          let date=new Date();
          let milis=date.getTime();
          this._appData.room={id:'noroom'+milis,name:'sem nome',textures:{meetingBackground:''},father:'1644803653158'}
        }
        this.checkUser();
        this.addToParty();
      }
      else{
        this._companyService.getRoom(roomToBe).get().then(r=>{
          this._appData.room=r.data();
          if (this.isIOS && this._appData.room.ios){
             this._companyService.getRoom(this._appData.room.ios).get().then(r2=>{
              this._appData.room=r2.data();
              this.completeRoomProcess();
             })
          }
          else{
              this.completeRoomProcess();
          }
        })
      }
    }
    public completeRoomProcess(){

          let itens=[]
          if (!this.shouldRunAndroid){
            this._companyService.getUserRoomItemRef(this._appData.room.id).get().then(it=>{
              it.forEach(v=>{
                let item=v.data();
                itens.push(item)
              })
              let room=JSON.parse(JSON.stringify(this._appData.room));
              room.userItens=itens;
              console.log(room)
              this.sendIframeMessage({kind:"setRoom",room:room})

            })
          }
          else{
            setTimeout(v=>{
              this.sendIframeMessage({kind:"setRoom",room:this._appData.room})
            },10000)

          }

          this.processAndroidStyle();
          this.processRoomMenu();

          $('#youtubeReload').click();
          //check company if company is relevant
          if (this._appData.room.company){
            this._companyService.getCompanyById(this._appData.room.company).get().then(comp=>{
              this.company=comp.data();
              this._appData.company=this.company;
              if (this.company){
                if (this.company.workers){
                  let meworklist=this.company.workers.filter(w=>{
                    return w.uid==this._appData.instagramUser.uid
                  })
                  if (meworklist.length>0){
                    this._appData.instagramUser.kind=meworklist[0].kind;
                  }
                }
              }

            })

          }


          if (this._appData.room.meeting &&  this._appData.page!='meeting' ){
            if (this._appData.page!='dashboard' && this._appData.page!='speakerroom'){
              let domain=window.location.origin
              window.location.replace(domain+"/meeting/"+this.event.id+"?room="+this._appData.room.id);
              return;

            }
          }
          if (this._appData.room.videoBackground){
            $("#main").css("background-color","");
            this.videoBackground="https://www.youtube.com/embed/"+this._appData.room.videoBackground+"?playlist="+this._appData.room.videoBackground+"&autoplay=1&loop=1&mute=1"
          }
          if (this._appData.room.photoBackground){
            $("#main").css("background-color","");
          }
          this.checkUser()
          //Vai atras de detalhes do evento
          this.defineGame(0);

          this.addToParty();
        

      


    }
    public controlEnteringModal(){

/*      $('#iframeModal').css('visibility','visible')
      let tour=[
        {photo:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Ftypes-of-tourism.jpg?alt=media&token=5f97199b-b32d-4824-bbe8-a9dba7f1c442',icon:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Ftravel-5360_256.gif?alt=media&token=be096da1-f7e1-4181-83eb-e0459500ff93',text:'Bem vindo ao Livetour. Estamos buscando seu destino turístico'},
        {photo:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Ftypes-of-tourism.jpg?alt=media&token=5f97199b-b32d-4824-bbe8-a9dba7f1c442',icon:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Foriginal-82706ccc12091ed6124237fa7cf65f23.gif?alt=media&token=2075ed19-032c-409b-9f54-1104ca684fcb',text:'Que bacana!! Você está indo para '+this._appData.room.roomName+' estou com inveja hein!'},
        {photo:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Ftypes-of-tourism.jpg?alt=media&token=5f97199b-b32d-4824-bbe8-a9dba7f1c442',icon:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Ftravel-5360_256.gif?alt=media&token=be096da1-f7e1-4181-83eb-e0459500ff93',text:'O teleporte para seu destino está esquentando....já já te levamos para lá'},
        {photo:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Ftypes-of-tourism.jpg?alt=media&token=5f97199b-b32d-4824-bbe8-a9dba7f1c442',icon:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Ftravel-5360_256.gif?alt=media&token=be096da1-f7e1-4181-83eb-e0459500ff93',text:'Teleportando visitante ao seu destino turístico favorito! Aproveite!!!'}
      ]
      let id=0
      if (this._appData.room.company!='LIVETOUR'){
        tour=[
          {photo:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Findustria.png?alt=media&token=66c3661a-df88-4c40-b3ff-d57771b2d27a',icon:this._appData.company ? this._appData.company.thumbnail : 'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Findustry4.0.gif?alt=media&token=4cbc5f07-5ca9-47b2-973c-d22c931859b5',text:'Bem vindo ao Liveteach. Estamos buscando seu destino industrial'},
          {photo:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Findustria.png?alt=media&token=66c3661a-df88-4c40-b3ff-d57771b2d27a',icon:this._appData.company ? this._appData.company.thumbnail : 'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Findustry4.0.gif?alt=media&token=4cbc5f07-5ca9-47b2-973c-d22c931859b5',text:'Esta pronto para seu treinamento? Estamos coletando seus EPIs'},
          {photo:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Findustria.png?alt=media&token=66c3661a-df88-4c40-b3ff-d57771b2d27a',icon:this._appData.company ? this._appData.company.thumbnail : 'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Findustry4.0.gif?alt=media&token=4cbc5f07-5ca9-47b2-973c-d22c931859b5',text:'O teleporte para seu destino está esquentando....já já te levamos para lá'},
          {photo:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Findustria.png?alt=media&token=66c3661a-df88-4c40-b3ff-d57771b2d27a',icon:this._appData.company ? this._appData.company.thumbnail : 'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/icons%2Findustry4.0.gif?alt=media&token=4cbc5f07-5ca9-47b2-973c-d22c931859b5',text:'Teleportando visitante ao seu destino de treinamento! Aproveite!!!'}
        ]

      }
      this.entryPhoto=tour[id].photo
      this.entryIcon=tour[id].icon;
      this.entryText=tour[id].text;        
      id++
//      this.entryInterval=setInterval(()=>{
        this.entryIcon=tour[id].icon;
        this.entryText=tour[id].text;        
        id++*/
  //    },5000)
    }
    public defineScreenStatus(){
      let screenStatus={
        menu:false,
        chat:false,
        stream:false,
        videoconf:false
      }
      if (this._appData.room.screenStatus){
        screenStatus=this._appData.room.screenStatus
      }
      if (this._appData.instagramUser.screenStatus){
        screenStatus=this._appData.instagramUser.screenStatus;
      }
      if (screenStatus.chat){

      }

      if (!screenStatus.videoconf){
        this.sendIframeMessage({kind:"updateVideoconf",visibility:false})
      }
    }

    public defineGame(option){
      //prioridade é 3d se eu tiver 3d.
      let hastd=false

      let backgrounds=this._appData.room.background
      if (backgrounds) {
        let bk=backgrounds[0]
        if (bk.photo){
          hastd=true;
        }
        if (bk.model){
          hastd=true;
        }

      }
      if (this._appData.room.backgroundPhoto && this._appData.room.backgroundPhoto.length>0){
        hastd=true;
      }
      if (this._appData.room.background3d && this._appData.room.background3d.length>0){
        hastd=true;
      }
      if (this._appData.room.backgroundMap){
        this.isMap=true;
        hastd=true;
        this._companyService.getMapSession()
      }

      if (this._appData.room.ar){
        hastd=true;
      }

      //option=1 =2d   option=2 = 3d  option=0 = tanto faz

      if (!hastd) option=1; //se eu nao tenho 3d option é sempre 1
      if (hastd && !option) option=2; //se eu tenho 3d e nao dou option a option é 2.

      if (this._appData.room.view=='2D'){
        option=1;
      }else if (
        this._appData.room.view=='RACE'
      ){
        option=4
      }

      if (this._appData.room.defaultSpace){
        this._appData.instagramUser.space=this._appData.room.defaultSpace
      }

      const roomId = this._appData.room.id;
      const photoBackground = encodeURIComponent(this._appData.room.photoBackground); // Encode the URL

      if (this.isIOS && this._appData.room.ios){
        this._appData.gameUrl="/gamephoto.html?uid="+this._appData.instagramUser.uid+"&room="+this._appData.room.ios
      }
      else{
        if (option == 1) {
          this._appData.gameUrl = `/gamephoto.html?room=${roomId}`;
        } else if (option == 2) {
          this._appData.gameUrl = `/gamephoto.html?room=${roomId}`;
          this.webGl = true;
          this._appData.webGl = true;
        } else if (option == 4) {
          this._appData.gameUrl = `/gamerace.html?uid=${this._appData.instagramUser.uid}&room=${roomId}&lg=${this.language}`;
        } else {
          this._appData.gameUrl = `/game.html?room=${roomId}`;
        }
      }
    }
    public checkUser(){
      this.user=this._appData.instagramUser;
      this._appData.headerOn=false;
      if (!this.user){
        //try memory
            let date=new Date();
            let id=date.getTime();
            id=-1*id;
            let room=this._appData.room.id;
            this._appData.instagramUser={uid:id.toString(),full_name:this.translate.instant('EVENT_COMPONENT_16'),tutorial:false,room:this._appData.room.id,profile_picture:'https://liveplanet.app.br/assets/landingstyle/profile.png'}
            this.sendIframeMessage({kind:'addMe',user:this._appData.instagramUser});
      }
      else {
        this._appData.profilePicture=this.user.profile_picture;
        let uid=this._appData.instagramUser.uid;
        if (this._appData.event.admins){
          this._appData.event.admins.forEach((val)=>{
            if (val==uid){
              this._appData.instagramUser.admin=true;
            }
          })
        }
      }
      if (this._appData.room.admin){
        this._appData.room.admin.forEach(val=>{
          if (val==this._appData.instagramUser.uid){
            this._appData.admin=true;
            this.admin=true;
          }
        })
      }
      this._walletService.getWallet('user',this._appData.instagramUser.uid).subscribe(val=>{
        if (val.status==200){
          this._appData.containerWallet=true;
        }
        else{
          if (!this.isNumber(this._appData.instagramUser.uid)){
            this._walletService.getCreateWallet('user',this._appData.instagramUser.uid).subscribe(val=>{
              this._appData.containerWallet=true;
            })
          }
        }
      },err=>{
        if (!this.isNumber(this._appData.instagramUser.uid)){
          this._walletService.getCreateWallet('user',this._appData.instagramUser.uid).subscribe(val=>{
            this._appData.containerWallet=true;
          })
        }
      })
      return;
    }
    public getEventParam(queryParam){
      this._companyService.getEventById(queryParam).subscribe(
            (_event: any) => {
                var obj = _event;
                if (obj.url){
                  obj=_event.json();
                }
                if (obj.length>0){
                  this.event=obj[0]
                }
                else{
                  this.event=obj;
                }
                let myevent:EventBean = this.event;
                this._appData.event=myevent;
                if (myevent){
                  this.fillEventData(myevent);
                }
            });
    }
    public registerUser(code){

    }
    public fillEventData(myevent:EventBean){
      let date=new Date(myevent.dateStart);
      if (window){
        setTimeout(()=>{
          window.scrollTo(0, 1);//MAKE it work webapp
        },10000)
      }
      this._appData.event=this.event;  //Here i fill the event on appData requisite

      this.getRoomFromParam();
    }
    public toggleVideoconf(){

      if (this._appData.jitsiOn){
        this.sendIframeMessage({kind:"updateVideoconf",visibility:false})
      }
      else{
        this.sendIframeMessage({kind:"updateVideoconf",visibility:true})
      }

      this._appData.jitsiOn=!this._appData.jitsiOn;


    }
    public streamToggle(){
      if (this._appData.room.map){
        let temp='https://liveplanet.app.br/gamephoto.html?room='+this._appData.room.map
        this._appData.stream=temp
        setTimeout(()=>{
          this._appData.stream=temp
          $('#youtubeOpen').click()
        },2000)
        if (this._appData.streamClose){
          $('#youtubeOpen').click()
        }
        else{
          $('#youtubeClose').click()
  
        }
  
      }
      this.sendIframeMessage({
                      kind:'toggleMap',
                      params:"toggleMap"
                    })

    }

    public addToParty(){

      let event = this.event;
      let user=this._appData.instagramUser;
      user.active=true;
      if (isNaN(this._appData.instagramUser.uid)) {
        //this is a unlogged user
        //update my avatar if needed
        if (!this._appData.event['avatarVersion']) this._appData.event['avatarVersion']=0
        if (this._appData.instagramUser.avatarVersion!=this._appData.event['avatarVersion']){
          let avatar=this._companyService.getAvatar();
          if (this._appData.instagramUser.sex=="M"){
            this._appData.instagramUser.avatar=avatar['male']['default']
          }
          else{
            this._appData.instagramUser.avatar=avatar['female']['default']
          }
          this._appData.instagramUser.avatarVersion=this._appData.event['avatarVersion']
          this._companyService.updateUserProperty("avatar",this._appData.instagramUser.avatar,this._appData.instagramUser)
          this._companyService.updateUserProperty("avatarVersion",this._appData.event['avatarVersion'],this._appData.instagramUser)
        }
        this._companyService.updateUserProperty("event",this._appData.event.id,this._appData.instagramUser)
        this._companyService.updateUserProperty("room",this._appData.room.id,this._appData.instagramUser)
        this._companyService.updateUserProperty("tutorial",1,this._appData.instagramUser)
        //I have a user...need to get its skills and container for the event
        if (!this._appData.userEventContainer || this._appData.userEventContainer.length==0){
          this._companyService.getUserContainerRef().get().then(cdata=>{
            let clist=[];
            cdata.forEach(c=>{
              let item=new ItemBean();
              item.parse(c.data())
              clist.push(item)
            })
            this._appData.userEventContainer=clist;
          })
          this._walletService.getCreateWallet('user',this._appData.instagramUser.uid).subscribe(val=>{
            if (val.status==200){
              this._appData.containerWallet=true
            }
          })

        }
        else{
        }


        if (!this._appData.userEventSkills || this._appData.userEventSkills.length==0){
          this._appData.userEventSkills=[];
          this._walletService.getCreateWallet('skills',this._appData.instagramUser.uid).subscribe(val=>{
            this._walletService.getTokenBalance('skills',this._appData.instagramUser.uid).subscribe(sk=>{
              let vet=sk.json();
              vet.forEach(element => {
                let address=element.mint_address
                let amount=element.ui_amount
                let skArr=this._appData.event.skills.filter((val)=>{
                  return val.tokenId==address
                })
                let skill=skArr[0];
                if (skill){
                  skill.value=10*Math.log2(amount)
                  this._appData.userEventSkills.push(skill)
                }
              });
            })

          })
        }
        if (!this._appData.eventRecipes || this._appData.eventRecipes.length==0){
          this._companyService.getRecipesRef(this._appData.event).get().then(val=>{
            this._appData.eventRecipes=[]
            val.forEach(r=>{
              let recipe=new RecipeBean();
              recipe.parse(r.data());
              this._appData.eventRecipes.push(recipe)
            })
          })
        }


      }//end of if for user logged
      else{
      }
      $("#chatReload").click();
      if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // Not adding `{ audio: true }` since we only want video now
        navigator.mediaDevices.getUserMedia({ audio: true }).then(function(stream) {
        });
      }
      this.startNotifications();
      this.getRoomItems();
      this.solveWrits();
      this.receiveIFrameMessages();
      if (this._appData.room.ar){
        document.getElementById('sidebar').remove()
        document.getElementById('menu-bar').remove()
        document.getElementById('icone-chat').remove();
        document.getElementById('icone-stream').remove();
        document.getElementById('icone-videoconf').remove();
        $('#registerSocialModal').modal('hide')
      }
      if (this._appData.room.multiplayer==0 && (window.location.pathname.indexOf('/social')==-1)){
        document.getElementById('sidebar').remove()
        document.getElementById('menu-bar').remove()
        document.getElementById('icone-chat').remove();
        document.getElementById('icone-stream').remove();
        document.getElementById('icone-videoconf').style.marginLeft='5px'
        //document.getElementById('icone-videoconf').remove();
        $('#registerSocialModal').modal('hide')
      }      
      let sp=this._appData.room.defaultSpace;
      if (!sp){sp=0} 
      this.addUserToSpace(sp);





      if (this.partyMembersRef){
        this.partyMembersRef()
      }
      this.partyMembersRef=this._companyService.getPartyMember(this._appData.event,this._appData.instagramUser).onSnapshot(snapshot => {
        let add=true;
        if (snapshot) {
          let user=snapshot.data();
          if (this._appData.instagramUser.ban){
            let timerInterval=null
            Swal.fire({
              title: "Você está banido",
              text: "Envie um email para contato@liveplanet.com.br pedindo a remoção do seu ban para que possamos analisar e te liberar para utilizar nossos serviços",
              timer: 10000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading()
                const b = Swal.getHtmlContainer().querySelector('b')
                timerInterval = setInterval(() => {
                  b.textContent = Swal.getTimerLeft()
                }, 100)
              },
              willClose: () => {
                clearInterval(timerInterval)
              }
            }).then((result) => {
              this._appData.instagramUser.ban=true;
              this._companyService.getPartyMember(this._appData.event,this._appData.instagramUser).set(this._appData.instagramUser);
             // this._companyService.addToBanList(this._appData.room,this._appData.instagramUser);
              window.open('https://liveplanet.com.br');
            })
            return;
          }
        }
        else{
          window.location.href="https://liveparty.com.br/"
        }
      })
      setTimeout(()=>{
        var userLang = navigator.language || navigator['userLanguage'];
        if (userLang.startsWith("pt")) {
                this.translate.use('pt');
        }
        else {
          this.translate.use('en');
        }

      },30000)
      setTimeout(()=>{
        this.fixRoomSound();
      },60000)
      setTimeout(()=>{
        this.defineScreenStatus();
      },10000)

  }
  public addUserToSpace(space){
    let date=new Date();
    let mi=date.getTime()*10;
    //ADD USER FOR OTHER USERS TO SEE
    this._companyService.getUserRoomPosition(this._appData.room.id).where('sp','==',space).orderBy('ch','desc').get().then(v=>{
      //see how many people is on the space i want to enter...
      let lastChannel=0
      let count=0;
      let hasLoop=false
      let maxAmount=this._appData.room.multiplayer ? this._appData.room.multiplayer : 1
      let found=false;
      v.forEach(us=>{
        hasLoop=true
        let user=us.data();
        if (!lastChannel){lastChannel=user.ch; count=1;}
        if (lastChannel==user.ch){
          count++;
        }
        if (count>maxAmount && !found){
          found=true;
          this._appData.channel=lastChannel+1
          this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid.toString()).set({uid:this._appData.instagramUser.uid,x:this._appData.room.defaultPlace.x,y:this._appData.room.defaultPlace.y,s:0,sp:0,f:true,t:mi,o:0,spa:[0],it:[],a:0,ch:this._appData.channel});
        }
        if (lastChannel!=user.ch && !found){
          found=true;
          this._appData.channel=lastChannel
          this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid.toString()).set({uid:this._appData.instagramUser.uid,x:this._appData.room.defaultPlace.x,y:this._appData.room.defaultPlace.y,s:0,sp:0,f:true,t:mi,o:0,spa:[0],it:[],a:0,ch:this._appData.channel});
        }
        if (!found){
          found=true;
          this._appData.channel=lastChannel
          this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid.toString()).set({uid:this._appData.instagramUser.uid,x:this._appData.room.defaultPlace.x,y:this._appData.room.defaultPlace.y,s:0,sp:0,f:true,t:mi,o:0,spa:[0],it:[],a:0,ch:this._appData.channel});
        }
      })
      if (!hasLoop){
        this._appData.channel=lastChannel
        this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid.toString()).set({uid:this._appData.instagramUser.uid,x:this._appData.room.defaultPlace.x,y:this._appData.room.defaultPlace.y,s:0,sp:0,f:true,t:mi,o:0,spa:[0],it:[],a:0,ch:this._appData.channel});
      }

    })
  }
  public gameToggle(){
    let option=this.tdswitch;
    let hastd=(this._appData.room.photos || this._appData.room.models);
    let hasdd=this._appData.room.background
    //option=0 =2d   option=1 = 3d

    if (option && !hasdd){
      Swal.fire({title:'Area sem 2d'})
    }
    if (option && hasdd){
      this._appData.gameUrl="/gamephoto.html?uid="+this._appData.instagramUser.uid+"&room="+this._appData.room.id
    }
    if (!option && !hastd){
      Swal.fire({title:'Area sem 3d'})
    }
    if (!option && hastd){
      if (this.isIOS && this._appData.room.ios){
        this._appData.gameUrl="/gamephoto.html?uid="+this._appData.instagramUser.uid+"&room="+this._appData.room.ios
      }
      else{
        this._appData.gameUrl="/gamephoto.html?uid="+this._appData.instagramUser.uid+"&room="+this._appData.room.id
      }
 
      this.webGl=true
      this._appData.webGl=true;
    }

  }

  public fixRoomSound(){
    let mic=this._appData.room.microphone;
    let baseVolume=this._appData.room.voiceStatus;
    let volume=-1;
    if (baseVolume==0){
      volume=-1;
    }
    if (baseVolume==1){
      volume=1;
    }
    if (baseVolume==-1){
      volume=0;
    }
    if (mic){
      let filter=mic.filter((v)=>{
        return v==this._appData.instagramUser.uid
      })
      let myvolume=volume

      if (filter.length>0){
        myvolume=1;
      }
      let messageKind={
        kind:'updateUserStatus',
        params:{uid:this._appData.instagramUser.uid,volume:myvolume,room:this._appData.room.id,baseVolume:volume}
      };
      this.sendIframeMessage(messageKind)


    }
  }
  public getLink(){
    let domain=window.location.origin
    navigator.clipboard.writeText(domain+'/gameevent/'+this._appData.event.id+'?room='+this._appData.room.id);
    Swal.fire(this.translate.instant('SUCCESS'),'Link da sala transferido para memória. Use Ctrl-V para colar o link em conversa com quem você quiser convidar.')
  }
    /*
    This method checks if user can enter the room.
    It can be called after we have a user on this._appData.instagramUser, a room in this._appData.room and an event in this._appData.event and a userContainer processed.;
    First it sees if the user is on ban list for the room...that case user is sent to parent room.
    This will check if the room is locked. if its unlocked user can enter
    IF room is locked...then user must have a key for the room in the container
    */
/*    private checkSecurity(){
      let canEnter=true;
      let onCompany=false;
      if (this._appData.instagramUser.uid<0){
        canEnter=false;
      }
      //get the room
          if (this._appData.room.locked){
            ///test if company has workers
            let company={dbId:this._appData.room.company.toString()}
            this._companyService.getCompanyWorkers(company).doc(this._appData.instagramUser.uid.toString()).get().then(v=>{
                let worker=v.data();
                if (worker){
                  onCompany=true;
                  canEnter=true;
                }
                if (!onCompany){
                  let key=this._appData.room.id;
                  if (this._appData.room.meeting){
                    key=this._appData.room.father;
                  }
                  if (!key){
                    canEnter=false;
                  }
                  else{
                    let hasKey=false;
                    if (this._appData.userEventContainer){
                      this._appData.userEventContainer.forEach(it=>{
                        if (it.param){
                          if (it.param.room==key){
                            hasKey=true;
                          }
                        }
                      })

                    }
                    if (!hasKey){
                      canEnter=false;
                    }
                  }
                }
                if (!canEnter){
                  Swal.fire("Sala Trancada","Você não tem a chave para acessar essa sala. Estamos lhe enviando para a sala anterior para que você possa usar nossos ambientes abertos.").then((val)=>{
                    if (this._appData.room.lockedUrl){
                      window.location.href=this._appData.room.lockedUrl;

                    }
                    else{
                      let domain=window.location.origin
                      let father=this._appData.room.father;
                      if (!father) father=1626799638931;
                      window.location.href=domain+"/gameevent/"+this._appData.event.id+'?room='+father;

                    }
                  })

                }

              })
            }


    }

*/
public gotoEditRoom(){
      if (this._appData.instagramUser){
        this._appData.cellScreen='editRoom'
        this._appData.toggleCellPhone=!this._appData.toggleCellPhone;
        this._appData.tiping=true;
      }
      else{
        $('#registerSocialModal').modal('show');
        this._appData.tiping=true;
      }
}
  public startNotifications(){

    if (this.eventNotificationFeed){
      this.eventNotificationFeed.off();
    }
    else{
      this.eventNotificationFeed=this._companyService.getEventNotificationFeed(this.event);
    }
    this.eventNotificationFeed.on("child_added", (snapshot, prevChildKey) =>{
      let _messages=snapshot.val();
      let key=snapshot.key;
        _messages.key=key;
        let date=new Date();
        let milis=date.getTime();//1 minuto
        //test if message is for me.
        if (_messages.uid){
          if (_messages.uid!=this._appData.instagramUser.uid){
            return;
          }
        }
        if (!_messages.read){
          _messages.read=true;
          this._companyService.addEventNotification(this.event,_messages);
          //room specific events
          if (_messages.room){
            if (this._appData.room.id==_messages.room){
              if (_messages.kind=='updateRoomVideo'){
                  this.event.video=(_messages.video);
                  this._appData.room.video=_messages.video;
                  this.event.videoDesk=_messages.video
                  $("#youtubeReload").click();
              }
              if (_messages.kind=='text'){
                if (_messages.userKind && _messages.userKind!=this._appData.instagramUser.kind){
                  return;
                }
                let obj={
                  title:_messages.subject,
                  text:_messages.message,
                  confirmButtonText: 'OK',
                  showCloseButton: true,
                };
                Swal.fire(obj)
              }
              if (_messages.kind=='updateUserProfile'){
                let messageKind={
                  kind:'updateUser',
                  params:{uid:_messages.subject,avatar:'',picture:_messages.picture}
                };
                this.sendIframeMessage(messageKind)

              }
              if (_messages.kind=='updateUserAvatar'){
                let messageKind={
                  kind:'updateUserAvatar',
                  params:{uid:_messages.subject,avatar:_messages.avatar,picture:''}
                };
                this.sendIframeMessage(messageKind)
              }
              if (_messages.kind=='updateUserName'){
                let messageKind={
                  kind:'updateUser',
                  params:{uid:_messages.subject,full_name:_messages.full_name}
                };
                this.sendIframeMessage(messageKind)
              }
            }
          }
          else{
            if (_messages.kind=='text'){
              if (_messages.group){
                if (this.company.workers){
                  this.company.workers.forEach(v=>{
                    if (v.uid==this._appData.instagramUser.uid){
                      if (v.kind==_messages.group){
                        let obj={
                          title:_messages.subject,
                          text:_messages.message,
                          confirmButtonText: 'OK',
                          showCloseButton: true,
                        };
                        if (_messages.image){
                          obj['imageUrl']=_messages.image;
                        }
                        Swal.fire(obj)
                      }
                    }
                  })
                }
              }
              else{
                let obj={
                  title:_messages.subject,
                  text:_messages.message,
                  confirmButtonText: 'OK',
                  showCloseButton: true,
                };
                if (_messages.image){
                  obj['imageUrl']=_messages.image;
                }
                Swal.fire(obj)

              }
            }
            if (_messages.kind=='video'){
              Swal.fire({
                title:_messages.subject,
                html:'<iframe id="frameNotification" style="width:100%;height:315px" src="'+_messages.video+'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
                confirmButtonText: 'Fechar Vídeo',
              })
            }


          }

        }

    });
    try{
      if (!this.worker){
        this.worker = new Worker('/assets/js/workers/notificationWorker.js');
        this.worker.addEventListener('message', (e)=> {
          var audio = new Audio('/assets/game/sounds/talkPrivate.wav');
          audio.play();
          this.notification=e.data;
            this._companyService.readNotification(this.event,this._appData.instagramUser,this.notification);
            if (this.notification.kind=='text'){
              Swal.fire({
                title:this.notification.subject,
                text:this.notification.message})
            }
            if (this.notification.kind=='askContact'){
              if (!this.notification.answer){
                //being a chat notification, it can only be showed if i am not on the right chat
                Swal.fire({
                  title:this.translate.instant('EVENT_COMPONENT_5'),
                  text:this.notification.message,
                  confirmButtonText: this.translate.instant('YES'),
                  cancelButtonText:this.translate.instant('NO'),
                  showCancelButton: true,
                  showCloseButton: true,
                }).then((result) => {
                  if (result.value) {
                    this._companyService.sendNotificationToSomeoneElse(this.event,this._appData.instagramUser,{uid:this.notification.senderUid,full_name:this.notification.senderName},'Pedido de Contato',this._appData.instagramUser.full_name+' aceitou seu pedido de contato!! Ele agora está no seu celular!!!','askContact','success',true)
                    Swal.fire({
                      title:'Contato entregue',
                      text:'O contato agora está disponível em seu celular.'
                    })
                    //search for recipe id
                    this._companyService.insertContact(this._appData.instagramUser,{uid:this._appData.friendOnEvent},true);
                    if (this._appData.eventRecipes){
                      this._appData.eventRecipes.forEach(rec=>{
                        if (rec.kind=='talkAward'){
                          rec.quantity=0;
                          //this._companyService.updateUserSkill(rec);
                        }
                      })
                    }
                  }
                  else if (result.dismiss=="cancel" || result.dismiss=="close" || result.dismiss=="backdrop") {
                    this._companyService.sendNotificationToSomeoneElse(this.event,this._appData.instagramUser,{uid:this.notification.senderUid,full_name:this.notification.senderName},'Pedido de Contato',this._appData.instagramUser.full_name+' rejeitou seu pedido de contato..','askContact','fail',true)
                  }
                });
              }
              else{
                Swal.fire({
                  title:'Pedido de contato',
                  text:this.notification.message,
                  confirmButtonText: 'OK',
                  showCloseButton: true,
                })
                if (this.notification.link=='success'){
                  this._appData.cellScreen='profile'
                  this._appData.talkTo={uid:this.notification.senderUid,full_name:''};
                  this._appData.toggleCellPhone=true;
                  this._companyService.getUserByUid(this._appData.instagramUser.uid).then(val=>{
                    let us=val.data();
                    this._appData.instagramUser=us;
                  })
                  if (this._appData.eventRecipes){
                    this._appData.eventRecipes.forEach(rec=>{
                      if (rec.kind=='talkAward'){
                        rec.quantity=0;
                        //this._companyService.updateUserSkill(rec);
                      }
                    })
                  }

                }
                else if (this.notification.link=='fail'){
                  Swal.fire({
                    title:'Pedido de contato',
                    text:this.notification.message,
                    confirmButtonText: 'OK',
                    showCloseButton: true,
                  })
                }
              }
            }
            else if (this.notification.kind=="seeLink"){
              Swal.fire({
                title:this.notification.subject,
                text:this.notification.message,
                confirmButtonText: 'Ver',
                cancelButtonText:'Fechar',
                showCancelButton: true,
                showCloseButton: true,
              }).then((result) => {
                if (result.value) {
                  //abrir celular no espaco
                  this._companyService.openExternalLink(this.notification.link,false)

                }
              })
            }
            else if (this.notification.kind=="ban"){
              let timerInterval
              Swal.fire({
                title: this.notification.title,
                text: this.notification.message,
                timer: 10000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  const b = Swal.getHtmlContainer().querySelector('b')
                  timerInterval = setInterval(() => {
                    b.textContent = Swal.getTimerLeft()
                  }, 100)
                },
                willClose: () => {
                  clearInterval(timerInterval)
                }
              }).then((result) => {

               // this._companyService.addToBanList(this._appData.room,this._appData.instagramUser);
                window.location.href='https://liveplanet.com.br';
              })

            }
            else if (this.notification.kind=="kick"){
              let timerInterval
              Swal.fire({
                title: this.notification.title,
                text: this.notification.message,
                timer: 10000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  const b = Swal.getHtmlContainer().querySelector('b')
                  timerInterval = setInterval(() => {
                    b.textContent = Swal.getTimerLeft()
                  }, 100)
                },
                willClose: () => {
                  clearInterval(timerInterval)
                }
              }).then((result) => {
                let domain=window.location.origin
                window.location.href='domain+"/gameevent='+this._appData.event.id+'&room='+this._appData.room.father;
              })
            }
            else if  (this.notification.kind=='callToLive'){
              //being a chat notification, it can only be showed if i am not on the right chat
              let shouldNotify=true;
              if (shouldNotify){
                Swal.fire({
                  title:'Convite pra entrar na Live de '+this.notification.senderName+ '. Ao aceitar o pedido desligaremos o video da sala e removeremos seu audio da videconferência para evitar microfonia. Você pode recuperá-lo se movendo na sala ou ligando manualmente o audio da videoconferência.' ,
                  text:this.notification.message,
                  confirmButtonText: 'Entrar',
                  cancelButtonText:'Fechar',
                  showCancelButton: true,
                  showCloseButton: true,
                }).then((result) => {
                  if (result.value) {
                    //abrir celular no espaco
                    this._appData.event.videoMobile="";
                    this._appData.event.videoDesk=""
                    this.sendIframeMessage({
                      kind:'executeJitsiCommand',
                      params:"toggleAudio"
                    });

                    window.open(this.notification.link, '_blank');
                   }
                });

              }
          }
            else if  (this.notification.kind=='newCellMessage'){
                //being a chat notification, it can only be showed if i am not on the right chat
                let shouldNotify=true;
                if (this._appData.toggleCellPhone && this._appData.cellScreen=='chat' && this._appData.talkTo.uid==this.notification.senderUid){
                  shouldNotify=false;
                }
                if (shouldNotify){
                  Swal.fire({
                    title:'Nova mensagem de '+this.notification.senderName,
                    text:this.notification.message,
                    confirmButtonText: 'Ler',
                    cancelButtonText:'Fechar',
                    showCancelButton: true,
                    showCloseButton: true,
                  }).then((result) => {
                    if (result.value) {
                      //abrir celular no espaco
                      this._appData.toggleCellPhone=true;
                      this._appData.cellScreen='chat'
                      this._appData.talkTo={uid:this.notification.senderUid,profile_picture:this.notification.link,full_name:this.notification.senderName}
                      setTimeout(()=>{
                        $('#cellChatReload').click()
                      },1000)
                    }
                  });

                }
            }
          else if  (this.notification.kind=='newCellTeleport'){
              //being a chat notification, it can only be showed if i am not on the right chat
              if (!this.notification.answer){
                    Swal.fire({
                    title:this.notification.subject,
                    text:this.notification.message,
                    confirmButtonText: 'IR',
                    cancelButtonText:'RECUSAR',
                    showCancelButton: true,
                    showCloseButton: true,
                    }).then((result) => {
                      if (result.value) {
                        //abrir celular no espaco
                        let idx=this.notification.link.indexOf('-');
                        let x=0;
                        let y=0;
                        if (idx>0){
                           x=this.notification.link.substring(0,idx);
                           y=this.notification.link.substring(idx+1);
                            this.sendIframeMessage({
                              kind:'updateUserStatus',
                              params:{walking:false,uid:this._appData.instagramUser.uid,location:{x:x,y:y}}
                            });
                        }
                        else{
                          let domain=window.location.origin
                          window.location.href = domain+"/gameevent/"+this._appData.event.id+"?room="+this.notification.link;
                        }
                      }
                      else if (result.dismiss=="cancel" || result.dismiss=="close" || result.dismiss=="backdrop") {
                        this._companyService.sendNotificationToSomeoneElse(null,this._appData.instagramUser,{uid:this.notification.senderUid,full_name:this.notification.senderName},"Pedido de teleporte recusado",this._appData.instagramUser.full_name+" recusou seu pedido de teleporte.","newCellTeleport",this._appData.event.id,true)
                      }
              });
            }
            else{
              Swal.fire({
                title:this.notification.subject,
                text:this.notification.message,
                confirmButtonText: 'OK',
                showCloseButton: true,});

            }
          }
          else if  (this.notification.kind=='newCellJitsi'){
            //being a chat notification, it can only be showed if i am not on the right chat
            let uid=this._appData.instagramUser.uid;
            let talkTo=this.notification.senderUid;
            var n = uid.localeCompare(talkTo);
            let link='';
            if (n<0){
              link=uid+"_"+talkTo;
            }else{
              link=talkTo+"_"+uid;
            }
            let roombase='viplprivatechat_'+link;

            if (!this.notification.answer){
                  Swal.fire({
                  title:this.notification.subject,
                  text:this.notification.message,
                  confirmButtonText: 'IR',
                  cancelButtonText:'RECUSAR',
                  showCancelButton: true,
                  showCloseButton: true,
                  }).then((result) => {
                    if (result.value) {
                      //abrir celular no espaco
                      this._companyService.sendNotificationToSomeoneElse(null,this._appData.instagramUser,{uid:this.notification.senderUid,full_name:this.notification.senderName},"Pedido de videoconferência aceito",this._appData.instagramUser.full_name+" aceitou seu pedido de videoconferência.","newCellJitsi",true,true)
                      let room={jitsiServer:'viplistas.com.br',id:roombase}
                      this.sendIframeMessage({
                        kind:'startVideoCall',
                        params:room,
                        type:'localConference'
                      });
                      let timerInterval
                      Swal.fire({
                        title: 'Conversa privada',
                        text: 'Você está saindo da conversa por proximidade e entrando em uma conversa privada. Espere o outro usuário entrar na conversa. Você pode a qualquer momento voltar a conversa por proximidade apertando no icone da porta no canto superior de sua tela.',
                        timer: 10000,
                        timerProgressBar: true,
                        didOpen: () => {
                          Swal.showLoading()
                          const b = Swal.getHtmlContainer().querySelector('b')
                          timerInterval = setInterval(() => {
                            b.textContent = Swal.getTimerLeft()
                          }, 100)
                        },
                        willClose: () => {
                          clearInterval(timerInterval)
                        }
                      }).then((result) => {
                        })

                    }
                    else if (result.dismiss=="cancel" || result.dismiss=="close" || result.dismiss=="backdrop") {
                      this._companyService.sendNotificationToSomeoneElse(null,this._appData.instagramUser,{uid:this.notification.senderUid,full_name:this.notification.senderName},"Pedido de videoconferência recusado",this._appData.instagramUser.full_name+" recusou seu pedido de videoconferência.","newCellJitsi",false,true)
                    }
            });
          }
          else{
            if (this.notification.link){//aceito
              let room={jitsiServer:'viplistas.com.br',id:roombase}
              this.sendIframeMessage({
                kind:'startVideoCall',
                params:room,
                type:'localConference'
              });
              let timerInterval
              Swal.fire({
                title:'Reunião privada',
                showCloseButton: true,
                text:'Você está entrando em uma reunião privada e saiu da conversa por proximidade. Para sair da conversa privada e voltar a conversa por proximidade clique no icone de sair no topo da tela.',
                timer: 10000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  const b = Swal.getHtmlContainer().querySelector('b')
                  timerInterval = setInterval(() => {
                    b.textContent = Swal.getTimerLeft()
                  }, 100)
                },
                willClose: () => {
                  clearInterval(timerInterval)
                }
              }).then((result) => {
                })
            }
            else{
              //recusado
              Swal.fire({
                title:this.notification.subject,
                text:this.notification.message,
                confirmButtonText: 'OK',
                showCloseButton: true,});
            }

          }
        }
        else if (this.notification.kind=='openAppLink'){
          return;
        }
        else{
          Swal.fire({
            title:this.notification.subject,
            text:this.notification.message,
            confirmButtonText: 'OK',
            showCloseButton: true,})
            .then((result) => {
              if (result.value) {
                //abrir celular no espaco
                this.sendIframeMessage({kind:'emojis',emoji:'spook'})
              }
            });      ;
          }




        }, false);
        this.worker.postMessage(this._appData.instagramUser.uid); // Send data to our worker.
      }
    }
    catch (err){}


    if (this.roomNotificationFeed){
      this.roomNotificationFeed.off();
    }
    else{
      this.roomNotificationFeed=this._companyService.getRoomNotifications(this._appData.room);
    }
    this.roomNotificationFeed.on("child_added", (snapshot, prevChildKey) =>{
      let _messages=snapshot.val();
      let key=snapshot.key;
      if (!_messages.read){
        _messages.key=key;
        this.notification=_messages;
        this._companyService.readRoomNotification(this._appData.room,_messages);
        if (_messages.kind=='enterRoom'){
          if (_messages.senderUid==this._appData.instagramUser.uid){
            return;//cant authorize myself
          }
          var swalObj={
            title: _messages.subject,
            showCloseButton: true,
            text: _messages.message,
            showConfirmButton:true,
            confirmButtonText:this.translate.instant('YES')
          }
          Swal.fire(swalObj).then( (resultok) =>{
            let date=new Date();
            let time=date.getTime();
            let name=this._appData.instagramUser.full_name;
            let notification={
              event:this._appData.event.id,
              time:time,
              senderUid:this._appData.instagramUser.uid,
              senderName:name,
              senderThumbnail:'',
              subject:'Autorização concedida',
              message:name+' autorizou sua entrada na sala',
              kind:'enterRoomAuthorized',
              link:_messages.senderUid,
              read:false,
              action:'',
              answer:''
            }
            this._companyService.addRoomNotification(this._appData.room,notification)
          });

        }
        else if (_messages.kind=="enterRoomAuthorized"){
          if (_messages.link!=this._appData.instagramUser.uid){
            return;//cant authorize myself
          }
          $("#jitsiReload").click();
        }
        else if (_messages.kind=='forcedTeleport'){

          //abrir celular no espaco
          if (this._appData.instagramUser.uid==_messages.subject){
            let idx=_messages.link.indexOf('-');
            let x=0;
            let y=0;
            if (idx>0){
                    x=this.notification.link.substring(0,idx);
                    y=this.notification.link.substring(idx+1);
                     this.sendIframeMessage({
                       kind:'updateUserStatus',
                       params:{walking:false,uid:this._appData.instagramUser.uid,location:{x:x,y:y}}
                     });
            }

          }
        }
        else if (_messages.kind=="gotoSite"){
          Swal.fire({
            title:this.translate.instant('EVENT_COMPONENT_6'),
            text:_messages.senderName+this.translate.instant('EVENT_COMPONENT_7'),
            confirmButtonText: this.translate.instant('YES'),
            cancelButtonText:this.translate.instant('NO'),
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            }).then((result) => {
              if (result.dismiss=='backdrop') {}
              else if (result.dismiss=='close') {}
              else if (result.dismiss=='cancel'){}
              else{
                window.location.href=_messages.link
              }
            })

        }
        else if (_messages.kind=="seeLink"){
          Swal.fire({
            title:_messages.subject,
            text:_messages.message,
            confirmButtonText: this.translate.instant('YES'),
            cancelButtonText:this.translate.instant('NO'),
            showCancelButton: true,
            showCloseButton: true,
          }).then((result) => {
            if (result.value) {
              //abrir celular no espaco
              this._companyService.openExternalLink(_messages.link,false)
            }
          })
        }
        else if (_messages.kind=="cameraFix"){
          if (this.notification.link){
            if (this._appData.instagramUser.uid!=this.notification.link){
              return;
            }
          }
          Swal.fire({
            title:this.translate.instant('EVENT_COMPONENT_8'),
            text:_messages.senderName+this.translate.instant('EVENT_COMPONENT_9'),
            confirmButtonText: this.translate.instant('YES'),
            cancelButtonText:this.translate.instant('NO'),
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            }).then((result) => {
              if (result.dismiss=='backdrop') {}
              else if (result.dismiss=='close') {}
              else if (result.dismiss=='cancel'){}
              else{
                let domain=window.location.origin
                window.location.href=domain+"/welcome?event="+this._appData.event.id+'&room='+this._appData.room.id;
            }
            })
        }
        else if (_messages.kind=="talkMode"){
          Swal.fire({title:_messages.subject,
            text:_messages.message});

          let link=_messages.link;
          let status=link.all;
          let mics=link.me;
          if (!mics) mics=[]
          if (status==-1){
            this._appData.room.voiceStatus=0;
          }
          else if (status==1){
            this._appData.room.voiceStatus=1;
          }
          else if (status==0){
            this._appData.room.voiceStatus=-1;
          }
          this._appData.room.microphone=mics;
          let filter=mics.filter(val=>{
            return val==this._appData.instagramUser.uid
          })
          let mystatus=status;
          if (filter.length>0){
            mystatus=1;
          }
          let messageKind={
            kind:'updateUserStatus',
            params:{uid:this._appData.instagramUser.uid,volume:mystatus,room:this._appData.room.id,baseVolume:status}
          };
          this.sendIframeMessage(messageKind);
        }
        else if (_messages.kind=="registerNotification"){
          if (this.notification.link){
            if (this._appData.instagramUser.uid!=this.notification.link){
              return;
            }
          }

          Swal.fire({
            title:_messages.subject,
            text:_messages.message,
            confirmButtonText: this.translate.instant('YES'),
            cancelButtonText:this.translate.instant('NO'),
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            }).then((result) => {
              if (result.dismiss=='backdrop') {}
              else if (result.dismiss=='close') {}
              else if (result.dismiss=='cancel'){}
              else{
                $('#registerSocialModal').modal('show')
                this._appData.tiping=true;

              }
            })
        }
        else if (_messages.kind=="avatarChange"){
          if (this.notification.link){
            if (this._appData.instagramUser.uid!=this.notification.link){
              return;
            }
          }
          Swal.fire({
            title:_messages.subject,
            text:_messages.message,
            confirmButtonText: this.translate.instant('YES'),
            cancelButtonText:this.translate.instant('NO'),
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            }).then((result) => {
              if (result.dismiss=='backdrop') {}
              else if (result.dismiss=='close') {}
              else if (result.dismiss=='cancel'){}
              else{
            this.gotoFashion();
              }
            })
        }
        else if (this.notification.kind=="kick"){
          if (this.notification.link){
            if (this._appData.instagramUser.uid!=this.notification.link){
              return;
            }
          }
          let timerInterval
          Swal.fire({
            title: this.notification.title,
            text: this.notification.message,
            timer: 10000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading()
              const b = Swal.getHtmlContainer().querySelector('b')
              timerInterval = setInterval(() => {
                b.textContent = Swal.getTimerLeft()
              }, 100)
            },
            willClose: () => {
              clearInterval(timerInterval)
            }
          }).then((result) => {
            let domain=window.location.origin
            window.location.href='domain+"/gameevent='+this._appData.event.id+'&room='+this._appData.room.father;
          })
        }
        else if (_messages.kind=="text"){
            let obj={
              title:_messages.subject,
              text:_messages.message,
              confirmButtonText: 'OK',
              showCloseButton: true,
            };
            if (_messages.image){
              obj['imageUrl']=_messages.image;
            }
            Swal.fire(obj)
        }
        else if (_messages.kind=='video'){
            Swal.fire({
              title:_messages.subject,
              html:'<iframe id="frameNotification" style="width:100%;height:315px" src="'+_messages.video+'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
              confirmButtonText: 'Fechar Vídeo',
            })
        }
        else if (_messages.kind=="roomChange"){
          let name=_messages.senderName;
          let objective=_messages.message;
          let lock=_messages.link
          this._appData.room.meetingName=name;
          this._appData.room.meetingObjective=objective;
          this._appData.room.locked=lock;
          this._companyService.readRoomNotification(this._appData.room,_messages);
          this._companyService.updateRoom(this._appData.room)
          $('#meetingRoomChangeForm').click()

        }
      }
    });




  }


  public help(){
    Swal.fire({
      title:"ESTOU COM DÚVIDAS!",
      text:"Temos atendimento exclusivo via WhatsAPP para suporte no Metaverso. Clique em IR para falar com nossa equipe.",
      showCloseButton: true,
      confirmButtonText: 'IR',
      //html:'<iframe id="frameNotification" style="width:100%;height:315px" src="'+"_messages.video"+'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
    }).then(result=>{
      if (result.value){
        if (this._appData.room.help){
          window.open("https://api.whatsapp.com/send?phone="+this._appData.room.help.phone+"&text="+this._appData.room.help.text+".","_blank")
        }
        else{
          window.open("https://api.whatsapp.com/send?phone=5521998562768&text=Eu estou com problemas e preciso de ajuda no Liveplanet.","_blank")
        }
      }
    })


  }
  public toggleAudio(){
    this.sendIframeMessage({
      kind:'executeJitsiCommand',
      params:"toggleAudio"
    });

  }

  public sendIframeMessage(messageKind){

		const event = new CustomEvent('angularMessage',{detail:messageKind});
		window.dispatchEvent(event);


/*
    var iframe = document.getElementById('gameFrame');
   // if (iframe == null) return;
  ///  var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
//    iWindow.postMessage(messageKind, "*");*/
  }
  public solveWrits(){
    let room=this._appData.room
      if (room.gamepath){
        this._appData.hasServer=true
        this.checkMobile();
      }
      else{
        this._appData.hasServer=false
      }

      if (room.writ){
        let wrt={id:room.writ.id}
        this.doWrit(wrt.id,room.writ.job)
      }
      if (room.writTest){
        let writ=new WritBean();
        writ.setCompanyService(this._companyService)
        writ.setAppData(this._appData)
        this._companyService.getUserWrit(this._appData.instagramUser,room.writTest.group.toString()).get().then(val=>{
          let wrt=val.data();
          writ.testJob(room.writTest,wrt);
        });
      }

      if (room.triggers){
        room.triggers.forEach(trigger=>{
          if (trigger.kind=='onetime'){
              let shouldtrigger=false;
              if (!this._appData.instagramUser.oneTimeTriggers) {
                shouldtrigger=true
                this._appData.instagramUser.oneTimeTriggers=[];
              }
              else{
                let myonetime=this._appData.instagramUser.oneTimeTriggers.filter(element => {
                      return element==trigger.id;
                });
                if (!myonetime) myonetime=[];
                if (myonetime.length==0){ shouldtrigger=true;}
              }
              if (shouldtrigger){
                this._appData.instagramUser.oneTimeTriggers.push(trigger.id);
                this._companyService.updateUserProperty('oneTimeTriggers',this._appData.instagramUser.oneTimeTriggers,this._appData.instagramUser);
                if (trigger.type='npc'){
                  this._appData.npc={npcId:trigger.param};
                  $("#npcReload").click();
                }
                else if (trigger.type='modal'){
                  let param=trigger.param;
                  let link=param;
                  this._appData.param=param;
                  $('#externalLinkModalClick').click();
                  $('#externalLinkModal').modal("show")
                  $('#externalLinkModal').on('hidden.bs.modal',  () =>{
                    // do something…
                    this._appData.param={link:'https://liveparty.com.br/iframeBase.html',name:''}
                  })
                  $('#externalLinkModalClick').click();
                }

              }

          }
          else if (trigger.kind=='everytime'){
            Swal.fire({title:trigger.title,text:trigger.text})
          }

         })
        }
  }
  public doWrit(kind,writData){
    let writ=new WritBean();
    writ.setCompanyService(this._companyService)
    writ.setAppData(this._appData)
    if (kind=='give'){  //I have a job to give
      if (this._appData.activeWrits && this._appData.activeWrits[writData.writ] && writData.job==0){
        this._appData.activeWrits[writData.writ]=null;//reset writ
      }
      writ.giveJob(writData);
    }
    if (kind=="associate"){//this question solves a writ
      //check if i have the associated writ to solve
      writ.associateJob(writData);
    }
    if (kind=='test'){
      if (!writData.group){writData.group=writData.writ;}
      if (!this._appData.activeWrits[writData.writ]){
        this._companyService.getUserWrit(this._appData.instagramUser,writData.group.toString()).get().then(val=>{
          let wrt=val.data();
          writ.testJob(writData,wrt);
        }) 
      }
      else{
        let wrt=this._appData.activeWrits[writData.writ];
        writ.testJob(writData,wrt);
      }
    }
  }
  public checkMobile(){
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
    if (!check){
      $('#checkVideoModal').modal('show');
      $('#checkVideoReload').click();
      this.mobile=false;
      this._appData.isMobile=false;
    }
    else{
      this.mobile=true;
      this._appData.isMobile=true;

    }
    return check;
  }




  ///////////////////////////
  /////////////////////////
  ///////////////////////////
  //////////////////////////

    //Receptor for game messages
    private receiveIFrameMessages(){
      let self=this;
      var eventMethod = window.addEventListener
			? "addEventListener"
			: "attachEvent";
      var eventer = window[eventMethod];
      var messageEvent = eventMethod === "attachEvent"
        ? "onmessage"
        : "message";

    	eventer(messageEvent, (e) => {
  		  switch  (e.data.kind) {
          ////videoconference iframe actions
          case 'restartRoom':{
            this.sendIframeMessage(e.data)
            break;
          }
          case 'audioUnavailable':{
            let swalObj={
              title: 'Audio indisponivel',
              text:'Você está participando de uma experiência social imersiva. Pedimos encarecidamente que autorize o seu audio e vídeo para ter máxima experiência de uso.',
            }
            Swal.fire(swalObj);
            break
          }
          case 'videoUnavailable':{
            let swalObj={
              title: 'Audio indisponivel',
              text:'Você está participando de uma experiência social imersiva. Pedimos encarecidamente que autorize o seu audio e vídeo para ter máxima experiência de uso.',
            }
            Swal.fire(swalObj);

            break
          }
          case 'userOnLocalConference':{
            let user=e.data.param.user;
            let join=e.data.param.join;
            if (join){
              //user entered the local conference
              if (!this._appData.localConference) {this._appData.localConference=[]}
              if (user.uid=='me'){
                //i entered
                this._appData.localConference.push({uid:this._appData.instagramUser.uid,jid:user.jid})
              }
              else{
                this._appData.localConference.push(user)
              }
            }
            else {
              //user left local conference
              if (user.uid=='me'){
                this._appData.localConference=null;
              }
              else{
                if (this._appData.localConference) {
                  this._appData.localConference=this._appData.localConference.filter(v=>{
                    v.jid!=user.jid;
                  })
                }
              }
            }
            break;
          }
/*          case 'writ':{
            parent.postMessage({"kind":'writ',param:{'writ':writ,text:this.param.text},distance:0,id:entity.objectId}, "*")
            let data=e.data.param.writ //{'writ':writ,text:this.param.text}
            if (data.writAssociation){
              //need to seek my writ and if it exists update saying i viewed
              let writ=new WritBean();
              writ.setCompanyService(this._companyService)
              writ.setAppData(this._appData)
              writ.associateJob(data.writAssociation);
            }
            else{
              let success=data.success//true ou false
              let text=data.text//texto do item que cliquei
              let date=new Date();
              let milis=date.getTime();
              let uid=this._appData.instagramUser.uid;
              this._companyService.getWritReport().doc(milis.toString()).set({
                'success':success,
                'text':text,
                'milis':milis,
                'uid':uid,
                'writKind':data.writ.kind
              })
            }
            this._appData.param=e.data.param
            $('#RoomItemModal').modal('show')
            $('#RoomItemModalClick').click();
            $('#RoomItemModal').on('hidden.bs.modal',  () =>{
              // do something…
              $('#RoomItemModalUnload').click()
              this._appData.focusIframe=""
            })
            break
          }*/
          case 'shareItemToUsers':{
            let item=e.data.item;
            let users=e.data.users;
            if (item){
              for (let prop in users){
                  //send notification to the user
                  if (prop!=this._appData.instagramUser.uid){
                    this._companyService.sendNotificationToSomeoneElse(this.event,this._appData.instagramUser,{uid:prop,full_name:''},'Compartilhamento de item',this._appData.instagramUser.full_name+' quer te mostrar um item. Você aceita ver?','seeLink',item.param.link,false)
                  }
                  else{
                    Swal.fire({
                      title:this.translate.instant('EVENT_COMPONENT_49'),
                      text:this.translate.instant('EVENT_COMPONENT_50'),
                      confirmButtonText: this.translate.instant('YES'),
                      cancelButtonText:this.translate.instant('NO'),
                      showCancelButton: true,
                      showCloseButton: true,
                    }).then((result) => {
                      if (result.value) {
                        //abrir celular no espaco
                        this._companyService.openExternalLink(this.notification.link,false)

                      }
                    })
                  }
              }
            }
            break;
          }
          case 'audioMuted':{
            if (this.muted){

            }
            else{
              this.sendIframeMessage({
                kind:'executeJitsiCommand',
                params:"toggleAudio"
              });
            }
            break
          }
          case 'videoMuted':{
            this.sendIframeMessage({
              kind:'executeJitsiCommand',
              params:"toggleVideo"
            });
            break
          }

          /////////////////////////////////
          case 'selectAvatar':{
            let item=e.data.param;
            let swalObj={
              title: 'Roupa de avatar',
              text:'Você deseja mudar seu avatar para esse modelo? Você pode sempre usar seu editor de avatar ou suas roupas para se personalizar de volta ao original.',
              showCloseButton: true,
              confirmButtonText: 'OK',
              preConfirm: () => {
                this._appData.object={avatar:item
                }
                $('#noAvatarModal').modal('show')
                $('#redrawAvatar').click();

              }
            }
            Swal.fire(swalObj);
            break;
          }
          case 'showVideo':{
            this.notification={subject:(e.data.subject),video:e.data.video};
            Swal.fire({
              title:e.data.subject,
              html:'<iframe id="frameNotification" style="width:100%;height:315px" src="'+e.data.video+'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
            })

            if (e.data.replace){
              this.event.video=e.data.video;
              this._appData.room.video=e.data.video
              $("#youtubeReload").click();
            }
            break;
          }
          case 'triggerNotification':{
            let room=e.data.param.goto;
            this._companyService.getTriggerNotificationData(this._appData.instagramUser.uid, e.data.param.rewardId).get().then(v=>{
              let reward=v.data();

              Swal.fire({title:'Parabéns você achou um prêmio',
              imageUrl: "https://usagif.com/wp-content/uploads/gift-5.gif",
              imageWidth: 400,
              imageHeight: 200,
              html:'O link do seu prêmio é <a target="_blank" href="'+reward.link+'">link</a>. Clique em ok para voltar para a praia',showCloseButton: true,
              confirmButtonText: 'OK',
              showCancelButton: false,
              }).then((result) => {
              if (result.value) {
                let domain=window.location.origin
                window.location.href = domain+"/gameevent/"+this._appData.event.id+"?room="+e.data.param.goto;
              }
              })
              this._companyService.getTriggerNotificationData(this._appData.instagramUser.uid, e.data.param.rewardId).update({seen:true}).then(v=>{console.log('update')})

            })
            break;
          }
          case 'endGame':{
            Swal.fire({title:e.data.param.title,
              text:e.data.param.text,
              confirmButtonText: "OK",
              allowOutsideClick: false,
            }).then((result) => {
              let domain=window.location.origin
              window.location.href = domain+"/gameevent/"+this._appData.event.id+"?room="+e.data.param.goto;
            })

          }
          case 'audio':{
            let muted=e.data.muted
            this.muted=muted;
            if (muted) {
              $('#audioBtn').css("background-position", "-80px -720px")
              this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid).update({a:21})
            }
            else{
              $('#audioBtn').css("background-position", "0px -720px")
              this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid).update({a:0})
            }

            break
          }
          //MOVABLE ITEM CLOSEACTIONS
          case 'closeOpenModal':{
            let param=e.data.param;
            param.id=e.data.id
            this._appData.param=param;
            this._companyService.openExternalLink(param.link,true)
            if (e.data.active){
              this._appData.activeItens[e.data.objectId]=true;
            }
            else{
              delete this._appData.activeItens[e.data.objectId];
            }

            break;
          }
          case 'closeSpeech':{
            let code=e.data.code
            if (e.data.code){
              this._appData.activeItens[e.data.objectId]=true;
              this._appData.localConference=e.data.objectId
              $("#chatReload").click();
            }
            else{
              code=''
              this._appData.localConference=null
              $("#chatReload").click();
              delete this._appData.activeItens[e.data.objectId];
            }
            this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid).update({s:code,it:this._appData.activeItens})
            break
          }

          case 'closeEmbed':{
            $('#move-control').click();
            this.gotoPista();
            this._appData.target={x:e.data.x,y:e.data.y}
            if (e.data.activate){
              if (!this._appData.activeItens[e.data.objectId]){
                this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid).update({it:this._appData.activeItens})
                this._appData.activeItens[e.data.objectId]=true;
              }
            }
            else{
              delete this._appData.activeItens[e.data.objectId];
              this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid).update({it:this._appData.activeItens})
            }
            if (e.data.action=='video'){//old case
              this._appData.selectedItem={distance:e.data.distance,dx:e.data.dX,dy:e.data.dY,link:e.data.link,id:e.data.id};
              this._appData.stream=e.data.param.video;
            }
            else if (e.data.param && e.data.param.video){
              this._appData.selectedItem={distance:e.data.distance,dx:e.data.dX,dy:e.data.dY,link:e.data.param.video,id:e.data.id};
              this._appData.stream=e.data.param.video;
            }
            else if (e.data.param && e.data.param.audio){
              this._appData.selectedItem={distance:e.data.distance,dx:e.data.dX,dy:e.data.dY,link:e.data.param.audio,id:e.data.id};
              this._appData.stream=e.data.param.audio;
            }
            else if (e.data.param && e.data.param.embed){
              this._appData.selectedItem={distance:e.data.distance,dx:e.data.dX,dy:e.data.dY,link:e.data.param.embed,id:e.data.id};
              this._appData.stream=e.data.param.embed;
            }
            else{
              if (this._appData.selectedItem){
                if (e.data.link != this._appData.selectedItem.link){
                  this._appData.selectedItem=null
                  this._appData.stream=e.data.link;
                }
              }
              else{
                this._appData.selectedItem=null
                this._appData.stream=e.data.link;
              }
            }
            $('#youtubeReload').click();
            break
          }
          case 'embed':{
            this._appData.target={x:this._appData.instagramUser.position.x,y:this._appData.instagramUser.position.y}
            this._appData.stream=e.data.param.link;
            $('#youtubeOpen').click()
            $('#youtubeReload').click();
            break
          }
          case 'addToEvent':{
            var code = e.data.resultCode;
            var participants = e.data.participants;
            var livecoins=e.data.livecoins;
            var cost=e.data.cost;
            var partyToGo=e.data.partyToGo;
            /*code==0
            code==1 vip acabou
            code==2 limite da festa
            */
            var title='';
            var text='';
            var confirmText='';
            if (code==1){
              title='Esse evento custa '+cost+' livecoins';
              if (livecoins>=cost){
                text='Esse evento já está com '+participants+' participantes. Você deseja usar '+cost+' dos seus '+livecoins+' Livecoins para entrar?'
              }
              else{
                text='Esse evento já está com '+participants+' participantes. Você só possui '+livecoins+' deseja comprar mais?'
              }
              confirmText=this.translate.instant('YES');
            }
            if (code==2){
              title='Esse evento está cheio';
              text='Esse evento já está com '+participants+' participantes e para permitir que o ambiente funcione na melhor experiência possível nós paramos as vendas';
              confirmText='Ok';
            }
            let swalObj={
              title: title,
              text:text,
              showCloseButton: true,
              confirmButtonText: confirmText,
              preConfirm: () => {
                if (code==1){
                  e.data.kind='payForEvent';
                  this.sendIframeMessage(e.data);
                }
              }
            }
            Swal.fire(swalObj);
          }
          case 'editObject':{
            this._appData.object=e.data.object;
            $('#editObjectReload').click();
            $('#editObjectModal').modal('show');
            break;
          }
          case 'addObject':{
            if (!this._appData.object){
              this._appData.object=e.data.object;
            }
            else{
              this._appData.object=JSON.parse(JSON.stringify(this._appData.object));
              this._appData.object.objectId=null;
              this._appData.object.position=e.data.object.position
            }
            $('#editObjectReload').click();
            $('#editObjectModal').modal('show');
            break;
          }
          case `streamArea`:{
            let data=e.data.data

            let canEdit=false;
            if (this._appData.instagramUser.uid=='T6sKpIAzwlPlYmEGgy2FuolQ2wN2'){
              canEdit=true
            }
            else{
              if (!this._appData.userEventContainer){
                this._appData.userEventContainer=[]
              }
              this._appData.userEventContainer.forEach(val=>{
                if (val.action=="key" && val.param){
                  if (val.param.room==this._appData.room.id){
                    canEdit=true;
                  }
                }
              })
            }

            if (canEdit){
                Swal.fire({
                  title: 'Stream',
                  text:'Você vai ser enviado para uma tela de videoconferência. Clique em transmitir ao vivo e depois ponha nela a chave do stream.',
                  showCancelButton: true,
                  confirmButtonText: 'ENTRAR',
                  showLoaderOnConfirm: true,
                }).then((result) => {
                  if (result.dismiss=='backdrop') {}
                  else if (result.dismiss=='close') {}
                  else if (result.dismiss=='cancel'){}
                  else{
                    this._companyService.openExternalLink('viplistas.com.br/stream'+this._appData.room.id,false)

                  }
              })

            }
            else{
              Swal.fire({
                title: 'Stream',
                text:'Você vai ser enviado para uma tela de videoconferência que estará sendo tranmitida para todos.',
                showCancelButton: true,
                confirmButtonText: 'ENTRAR',
                showLoaderOnConfirm: true,
              }).then((result) => {
                if (result.dismiss=='backdrop') {}
                else if (result.dismiss=='close') {}
                else if (result.dismiss=='cancel'){}
                else{
                  this._companyService.openExternalLink('viplistas.com.br/stream'+this._appData.room.id,false)

                }
            })
          }
            break;
          }
          case `saveGrid`:{
            let data=e.data.data
            let type=e.data.type
            data=data.filter(val=>{
              return val;
            })
            this._appData.room[type]=data;
            this._companyService.updateRoom(this._appData.room)
            break;
          }
          case `saveLocalTalk`:{
            let localTalks=e.data.localTalks
            this._appData.room.localTalks=localTalks;
            this._companyService.updateRoom(this._appData.room)
            break;
          }
          case `saveTransparency`:{
            let transparency=e.data.transparency
            this._appData.room.transparency=transparency;
            this._companyService.updateRoom(this._appData.room)
            break;
          }
          case 'updateRoomObject':{
            this._appData.object=e.data.param;
            if (this._appData.object.param){
              this._appData.object.param.distance=0;
            }

            if (this._appData.object.param && this._appData.object.param.writAssociation && this._appData.object.param.writAssociation.kind=='position' ){
              this.doWrit('association',this._appData.object.param.writAssociation)
            }

            this._companyService.updateRoomObject(this._appData.object)
            break;
          }
          case 'container':{
            if (e.data.param.isTrello){
              this._appData.object={objectId:e.data.param.trelloListId}
              $('#containerModalTrello').modal('show')
              $('#containerModalTrelloClick').click();
            }
            else if (e.data.param.isDB){
              if (isNaN(this._appData.instagramUser.uid)){
                this._appData.object={objectId:e.data.param.objectId,distance:e.data.param.distance,thumbnail:e.data.param.thumbnail,name:e.data.param.name};
                if (this._appData.object.distance>300){
                  Swal.fire({title:this.translate.instant('EVENT_COMPONENT_14'),text:this.translate.instant('EVENT_COMPONENT_15')})
                  return;
                }
                $('#containerModal').modal('show')
                $('#containerModalClick').click();
              }
              else{
                Swal.fire({title:this.translate.instant('EVENT_COMPONENT_16'),text:this.translate.instant('EVENT_COMPONENT_17')})
              }

            }
            else{//memory based
              this._appData.object={objectId:e.data.id,itens:e.data.param.itens}
              $('#memorycontainerModal').modal('show')
              $('#memorycontainerModalClick').click();
            }

            break
          }
          case 'addToContainer':{
            let it=e.data.param;
            let container=e.data.container;

            if (it.triggers.onGrab){
              it.triggers.onGrab.forEach(v=>{
                if (v.kind=='containable'){
                  it.closeAction='trelloCard';
                  it.closeParam=v.param
                }
              })
            }
            if (!it.closeParam){
              return;
            }
/*            if (container.param.writTest){
              let writ=new WritBean();
              writ.setCompanyService(this._companyService)
              writ.setAppData(this._appData)
              container.param.writTest.itens=container.param.itens;
              writ.testJob(container.param.writTest);
            }
            if (container.param.writAssociation){
              let writ=new WritBean();
              writ.setCompanyService(this._companyService)
              writ.setAppData(this._appData)
              container.param.writAssociation.itens=container.param.itens;
              writ.associateJob(container.param.writAssociation,null);
            }*/
           //test if container is of kind trello
           let containerAction=null
           if (container.triggers.onClick){
              container.triggers.onClick.forEach(ac=>{
                if (ac.kind=='container'){
                  containerAction=ac;
                }
              })
           }
            if (containerAction && containerAction.param.trelloListId && it.closeAction=='trelloCard' || containerAction.param.isDB){
                Swal.fire({
                  title:'Adicionar ao container',
                  text:'Você deseja adicionar o item '+it.name+' ao container?',
                  confirmButtonText: this.translate.instant('YES'),
                  cancelButtonText:this.translate.instant('CANCEL'),
                  showCloseButton: true,
                  showCancelButton: true,
                  focusConfirm: false,
                }).then((result) => {
                        if (result.dismiss=='backdrop') {}
                        else if (result.dismiss=='close') {}


                        else if (result.dismiss=='cancel'){}
                        else{
                            if (it.closeParam.trelloId){
                              this._companyService.moveTrelloCardToList(it,containerAction.param.trelloListId,'roomObjects','remove')
                            }

                        }
                  });
              }
              else if (containerAction.param.memory){
                setTimeout(v=>{
                  it.position.x=5000
                  it.position.y=5000
                  it.position.z=5000
                  this._companyService.getUserRoomItemRef(this._appData.room.id).doc(it.objectId.toString()).set(it).then( v=>{})

                },2000)
              }
            break;
          }
          case 'equipUser':{
            let avatarModel=e.data.param
            this._appData.instagramUser.avatarModel=avatarModel
            this._companyService.updateUserProperty('avatarModel',avatarModel,this._appData.instagramUser)

            break
          }
          case 'collect':{
            let distance=e.data.param.distance
            let object=e.data.param.obj;
            let name=object.name
            let reach=object.reach ? object.reach : 2
            this._appData.object=object;
            if (distance>reach*150 && object.static){
              Swal.fire({title:this.translate.instant('EVENT_COMPONENT_14') +name,text:this.translate.instant('EVENT_COMPONENT_15')})
              return;
            }
            if (object.static){
              let canEdit=false;
              canEdit=object.owner==this._appData.instagramUser.uid
              if (!canEdit){
                if (!object.admin){object.admin=[]}
                try{
                  let filt=object.admin.filter(v=>{
                    return v==this._appData.instagramUser.uid;
                  })
                  if (filt.length>0) {
                    canEdit=true
                  }
                }
                catch(err){}
              }
              if (this._appData.room.admin && this._appData.room.admin.length>0){
                this._appData.room.admin.forEach(v=>{
                  if (v==this._appData.instagramUser.uid){
                    canEdit=true
                  }
                })
              }
              
              if ( canEdit){
                Swal.fire({
                  title:this.translate.instant('EVENT_COMPONENT_10'),
                  text:this.translate.instant('EVENT_COMPONENT_11'),
                  confirmButtonText: this.translate.instant('YES'),
                  cancelButtonText:this.translate.instant('CANCEL'),
                  showCloseButton: true,
                  showCancelButton: true,
                  focusConfirm: false,
                  }).then((result) => {
                    if (result.dismiss=='backdrop') {}
                    else if (result.dismiss=='close') {}
                    else if (result.dismiss=='cancel'){}
                    else{
                      object.static=false;
                      this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this._appData.object.objectId.toString()).set(object).then(v=>{
                        Swal.fire({title:this.translate.instant('SUCCESS'),text:this.translate.instant('EVENT_COMPONENT_12')})
                        this.sendIframeMessage({
                          kind:'updateItem',
                          item:object
                        })
                      });
                    }
                  });
                }
                else{
                  Swal.fire({
                    title:this.translate.instant('EVENT_COMPONENT_10'),
                    text:this.translate.instant('EVENT_COMPONENT_13')})

                }

            }
            else{
              $('#itemManipulationModal').modal('show')
              $("#itemManipulationReload").click()
            }
            break
          }
          case 'recipe':{
            let recipeId=e.data.param.recipe
            let distance=e.data.param.distance
            let id=e.data.id;
            //pre-requisites
            if (distance>300){
              Swal.fire({title:this.translate.instant('EVENT_COMPONENT_14'),text:this.translate.instant('EVENT_COMPONENT_15')})
              return;
            }

            if (!this._appData.eventRecipes){
              this._companyService.getRecipesRef(this._appData.event).get().then(val=>{
                this._appData.eventRecipes=[]
                val.forEach(r=>{
                  let recipe=new RecipeBean();
                  recipe.parse(r.data());
                  this._appData.eventRecipes.push(recipe)
                })
              })
            }
            else{
              let recipeArr=this._appData.eventRecipes.filter(r=>{
                return r.id==recipeId
              })
              let recipe=recipeArr[0];

              if (recipe.kind=='timeLapse'){
                if (e.data.param.name) {recipe.name=e.data.param.name}
                if (e.data.param.itemKind) {recipe.kind=e.data.param.itemKind}
                if (e.data.param.itemId) {recipe.id=e.data.param.itemId}
                this._walletService.updateUserSkill(recipe)
              }
              if (recipe.kind=='talkAward'){
                this._walletService.updateUserSkill(recipe)
              }

              if (recipe.kind=='harvest' || recipe.kind=='coin'){
                //see if this object was clicked 3times
                let strhavested=localStorage.getItem('harvested')
                let harvested=JSON.parse(strhavested);
                if (harvested){
                  let lastmili=harvested.date;
                  let tdate=new Date();
                  let milis=tdate.getTime();
                  if ((milis-lastmili)>(1000*60*60*24)){
                    harvested={date:milis}
                  }
                  let value=harvested[id]
                  if (!value) value=0;
                  harvested[id]=value;
                  let maxharvest= recipe.maxharvest ? recipe.maxharvest : 3
                  if (harvested[id]==maxharvest){
                    Swal.fire({title:'Objeto já trabalhado',text:'Você já usou este objeto '+maxharvest+'x e não há nada para trabalhar mais neste objeto.'})
                    return;
                  }
                  else{
                    harvested[id]=harvested[id]+1;
                  }
                }
                else{
                  harvested={}
                  harvested[id]=1;
                  let tdate=new Date();
                  let milis=tdate.getTime();
                  harvested['date']=milis;
                }
                localStorage.setItem('harvested',JSON.stringify(harvested))
                this._appData.stream=recipe.video;
                $('#youtubeReload').click();
                this.sendIframeMessage({
                  kind:'updateUserStatus',
                  params:{walking:false,uid:this._appData.instagramUser.uid,state:'fight'}
                });
                this._walletService.updateUserSkill(recipe)

                setTimeout(()=>{
                  this._appData.stream='';
                  $('#youtubeReload').click();
                  this.sendIframeMessage({
                    kind:'updateUserStatus',
                    params:{walking:false,uid:this._appData.instagramUser.uid,state:'stop'}
                  });
                },recipe.timeInSeconds*1000)
                this.sendIframeMessage


              }
              if (recipe.kind=='equipment'){
                this._appData.object=recipe;
                this._appData.param={link:recipe.video,name:'Equipamento'};
                $('#craftMenuModal').modal('show');
                $('#craftMenuModalClick').click();
              }
            }

            break;
          }
          case 'symplaLogin':{
            Swal.fire({
              title: 'Ticket para entrar',
              text:'Digite o número do seu ticket para entrar no evento.',
              input: 'text',
              inputAttributes: {
                autocapitalize: 'off'
              },
              showCancelButton: true,
              confirmButtonText: 'Confirmar',
              showLoaderOnConfirm: true,
              preConfirm: (login) => {
              },
              allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
              if (result.value) {
                let ticket=result.value;
                Swal.fire({title:'Processando',text:'Estamos processando seus dados no Sympla. Aguarde...'})
                this._companyService.checkinSymplaUser(result.value).subscribe((val)=>{
                  if (val.status==200){
                    let data=val.json();
                    //data in this case is the user.
                    this._appData.instagramUser=data;
                    if (typeof window !== "undefined" && localStorage){
                      localStorage.setItem('instagramUser',JSON.stringify(data))
                    }
                    this._companyService.getUserContainer(true);
                    let domain=window.location.origin
                    window.location.replace(domain+"/gameevent/"+this._appData.event.id+"?room="+this._appData.room.id);

                  }
                  else if (val.status==400){
                    Swal.fire({title:'Checkin já realizado',text:'Esse código já foi utilizado para checkin. Se você entrar você vai remover que estiver no evento para fora. Você deseja entrar?'})
                  }
                  else if (val.status==401){
                    Swal.fire({title:'Erro da autorização',text:'Esse código não foi autorizado para entrar no evento'})
                  }
                  else if (val.status==404){
                    Swal.fire({title:'Erro da autorização',text:'Esse participante não foi encontrado'})
                  }

                  //400 Participante com check-in já realizado
                //401 Erro de autorização
                //404 Participante não encontrado
                },err=>{
                  if (err.status==400){
                    Swal.fire({
                      title: 'Checkin já realizado',
                      text:'Você pode entrar pois você já está autorizado',
                    })
                  }
                  else if (err.status==401){
                    Swal.fire({title:'Erro da autorização',text:'Esse código não foi autorizado para entrar no evento'})
                  }
                  else if (err.status==404){
                    Swal.fire({title:'Erro da autorização',text:'Esse participante não foi encontrado'})
                  }
                  else{
                    Swal.fire({title:'Erro',text:'Ocorreu um erro...fale com os administradores do evento.'})

                  }
                })
              }
            })
            break;
          }
          case "insideGame":{//open inside game
            this._appData.param={link:e.data.param.link,name:e.data.name}
            $('#containerModal').modal('hide')
            $('#externalLinkModal').modal('show')
            $('#externalLinkModalClick').click();
            break
          }
          case "updateItemAnimation":{//open inside game
            this.sendIframeMessage({
              kind:'updateItemAnimation',
              params:e.data.param
            });
            break
          }

          case 'dresser':{
            let param=e.data.param;
            Swal.fire({
              title:'Faça seu avatar',
              text:'Você será direcionado para o editor de avatar onde poderá escolher vestimentas.',
              confirmButtonText: this.translate.instant("YES"),
              preConfirm: () => {
                let link='https://liveplanet.app.br/avatar?uid='+this._appData.instagramUser.uid+'&room='+this._appData.room.id+'&dresser='+param.dresserId+'&cid='+this._appData.room.company
                location.replace(link);
               }
              })
            break
          }
          case 'getUsers':{
            let data=e.data;
            this.getUserPositions();
            break;
          }
          case 'mouseChange':{
            let data=e.data;
            document.body.style.cursor = data.param.type;
            break;
          }
          case 'notify':{
            let data=e.data;
            Swal.fire({title:data.title,text:data.text})
            break;
          }
          case 'notifyClose':{
            let uid=e.data.param.uid
            this._companyService.sendNotificationToSomeoneElse(this._appData.event, this._appData.instagramUser, {uid:uid}, 'Yoink', this._appData.instagramUser.full_name + ' está próximo de você e quer te ouvir.', 'Yoink', 0, null)
            break
          }
          case 'door':{
            let door=new Door();
            door.objectId=e.data.id;
            door.param=e.data.param
            door.position=e.data.position
            door.orientation=e.data.orientation
            door.dimension=e.data.dimension
            let writText=null
            if (door.param.writ){
              let writ=new WritBean();
              writ.setCompanyService(this._companyService)
              writ.setAppData(this._appData)
              writ.giveJob(door.param.writ);
              writText='writ'
            }
            else if (door.param.writTest){
              let writ=new WritBean();
              writ.setCompanyService(this._companyService)
              writ.setAppData(this._appData)
              let interval=setInterval(()=>{
                if (writ.processCompleted){
                  if (writ.testSuccess){
                    door.setAppData(this._appData)
                    door.setCompanyService(this._companyService);
                    door.setTranslation(this.translate);
                    door.openDoor(door);

                  }
                  clearInterval(interval);
                }
              },1000)
              writText="test";
            }

            if (!writText){
              door.setAppData(this._appData)
              door.setCompanyService(this._companyService);
              door.setTranslation(this.translate);
              door.openDoor(door);

            }
            break;
          }
          case 'eventDoor':{
            let door=new Door();
            door.objectId=e.data.id;
            door.param=e.data.param

            door.setAppData(this._appData)
            door.setCompanyService(this._companyService);
            door.setTranslation(this.translate);
            door.openDoor(door);
            break;
          }
          case 'teleportDoor':{
            let door=new Door();
            door.objectId=e.data.id;
            door.param=e.data.param

            door.setAppData(this._appData)
            door.setCompanyService(this._companyService);
            door.setTranslation(this.translate);
            door.openDoor(door);

            break;
          }
          case 'dance':{
            let swalObj={
                title: this.translate.instant("DANCE_TITLE"),
                showCloseButton: true,
                text: this.translate.instant("DANCE_MESSAGE"),
                confirmButtonText: this.translate.instant("YES"),
                preConfirm: () => {
                  this.sendIframeMessage({
                    kind:'updateUserStatus',
                    params:{walking:false,uid:this._appData.instagramUser.uid,state:'dance'}
                  });
                }
            }
            Swal.fire(swalObj);
            break;

          }
          case 'defineRoomVideo':{
            let hasKey=false;


            if (this._appData.room.key){

              let key=this._appData.room.key;
              let filt=this._appData.userEventContainer.filter((val)=>{
                return val.name==key
              })
              hasKey=(filt.length>0)
            }
            else{
              hasKey=false;
            }
            if (this._appData.instagramUser.admin) {
              hasKey=true;
            }



            if (!hasKey){
              Swal.fire({
                title: this.translate.instant('EVENT_COMPONENT_47') ,
                text: this.translate.instant('EVENT_COMPONENT_48')
              });
              return;
            }
            $(`#roomMediaControlModal`).modal('show')
            $('#mediaControlChange').click();

            break;
          }

          case 'updatePanorama':{
            let param=e.data.param;
            //need to find the right panorama
            this._appData.room.backgroundPhoto.forEach(pan=>{
              if (pan.id==param.panorama){
                pan.rotate=param.rotation
                delete pan.r;
              }
            })
            this._companyService.updateRoom(this._appData.room)
            break            
          }          
          case 'updateTransition':{
            let param=e.data.param;
            //need to find the right panorama
            let hasIds=true;
            try{
              let myid=this._appData.room.backgroundPhoto[e.data.param.panorama].id
              if (!myid){
                let id=0;
               this._appData.room.backgroundPhoto.forEach(pan=>{
                  pan.id=id
                  id++;
                })             
              }
              this._appData.room.backgroundPhoto.forEach(pan=>{
                if (pan.id==param.panorama){
                  pan.transitions.forEach(tr=>{
                    if (tr.idx==param.idx){
                      tr.x=param.position.x
                      tr.y=param.position.y
                      tr.z=param.position.z
                      tr.rx=param.rotation.x
                      tr.ry=param.rotation.y
                      tr.rz=param.rotation.z
                      tr.nextAngle=param.nextAngle ? param.nextAngle : 0
                      delete tr.r;
                      tr.sx=param.scale.x
                      tr.sy=param.scale.y
                      tr.sz=param.scale.z
  
                    }
                  })
                }
              })

            }
            catch (err){
              this._appData.room.backgroundPhoto.forEach(pan=>{
                if (pan.id==param.panorama){
                  pan.transitions.forEach(tr=>{
                    if (tr.idx==param.idx){
                      tr.x=param.position.x
                      tr.y=param.position.y
                      tr.z=param.position.z
                      tr.rx=param.rotation.x
                      tr.ry=param.rotation.y
                      tr.rz=param.rotation.z
                      tr.nextAngle=param.nextAngle ? param.nextAngle : 0
                      delete tr.r;
                      tr.sx=param.scale.x
                      tr.sy=param.scale.y
                      tr.sz=param.scale.z
  
                    }
                  })
                }
              })
  
            }
            this._companyService.updateRoom(this._appData.room)
            break            
          }

          case 'recordAngle':{
            let param=e.data.params;
            let transition=param.transition;
            let angle=param.angle;
            let space=param.space;
            

            for (let spaceIndex=0;spaceIndex<this._appData.room.backgroundPhoto.length;spaceIndex++){
              if (this._appData.room.backgroundPhoto[spaceIndex].id==space){
                for (let transitionIndex=0;transitionIndex<this._appData.room.backgroundPhoto[spaceIndex].transitions.length;transitionIndex++){
                  if (this._appData.room.backgroundPhoto[spaceIndex].transitions[transitionIndex].idx==transition){
                    this._appData.room.backgroundPhoto[spaceIndex].transitions[transitionIndex].nextAngle=angle;
                    this._companyService.getRoom(this._appData.room.id).set(this._appData.room);
                    Swal.fire({title:'Sucesso',text:'Transição atualizada'})
                    break
                  }
                }
              }
            }
            break
          }
          case 'position':{
            let date=new Date();
            let t=date.getTime();
            this._appData.spaceToEdit=null;
            if ((t-this.lastChangeTime)<100 && !e.data.force){
              return;
            }
            this.lastChangeTime=t;
            let x=e.data.x
            let y=e.data.y;
            let z=e.data.z ? e.data.z : 0

            if (x == undefined || y== undefined ){
              return;
            }
            let speech=e.data.speech
            let space=e.data.space
            let spa=[0]
            if (this._appData.room.background2d && this._appData.room.background2d.length>0 && !this._appData.room.background){
              this._appData.room.background=this._appData.room.background2d
            }
            if (space!=null && this._appData.room.background){
              if (this._appData.room.background[space].spa){
                spa=this._appData.room.background[space].spa
              }
              if (this._appData.room.background[space].transitions){
                spa=[]
                this._appData.room.background[space].transitions.forEach(s=>{
                  spa.push(s.idx)
                })
              }
            }
            if (space!=null && this._appData.room.backgroundPhoto && this._appData.room.backgroundPhoto.length>0){
                spa=[space]
                if (this._appData.instagramUser.space>=this._appData.room.backgroundPhoto.length){
                  this._appData.instagramUser.space=this._appData.room.defaultSpace ? this._appData.room.defaultSpace : 0;
                }
            }
            if (space!=null && this._appData.room.background3d && this._appData.room.background3d.length>0){
              let filt=this._appData.room.background3d.filter(v=>{
                return space==v.id;
              })
              let roomSpace=filt[0]
              if (roomSpace&& roomSpace.transitions){
                spa=[]
                spa.push(space)
                roomSpace.transitions.forEach(v=>{
                  spa.push(v.idx)
                })

              }
          }

            let orientation=e.data.orientation;
            if (!space) {
              if (this._appData.room.spaceSpec){
                let spaceSpec=this._appData.room.spaceSpec;
                let cols=this._appData.room.spaceSpec.columns
                let rows=this._appData.room.spaceSpec.rows
                let rx=this._appData.room.spaceSpec.x
                let ry=this._appData.room.spaceSpec.y
                let myx=Math.floor(x/rx)
                let myy=Math.floor(y/ry)
                space=myy*rows+myx
                spa=[space-spaceSpec.columns-1,space-spaceSpec.columns,space-spaceSpec.columns+1,space-1,space,space+1,space+spaceSpec.columns-1,space+spaceSpec.columns,space+spaceSpec.columns+1]
              }
              else{
                space=0
              }
            }
            else{
              if (this._appData.room.spaceSpec){
                let spaceSpec=this._appData.room.spaceSpec;
                spa=[space-spaceSpec.columns-1,space-spaceSpec.columns,space-spaceSpec.columns+1,space-1,space,space+1,space+spaceSpec.columns-1,space+spaceSpec.columns,space+spaceSpec.columns+1]
              }
            }
            if (!speech) {speech=''}
            if (! orientation) { orientation=0 }
            let a=this.muted ? 21 : 0
            if (e.data.uid){
              if (e.data.uid==this._appData.instagramUser.uid){
                if (!x) {x=0}
                if (!y) {y=0}
                if (!z) {z=0}
                if (e.data.force){
                  this._companyService.getUserRoomPosition(this._appData.room.id).doc(e.data.uid.toString()).set({uid:e.data.uid,x:x,y:y,z:z,s:speech,sp:space,f:true,t:t,o:orientation,spa:spa,it:this._appData.activeItens,a:a,ch:this._appData.channel});
                }
                else{
                  this._companyService.getUserRoomPosition(this._appData.room.id).doc(e.data.uid.toString()).set({uid:e.data.uid,x:x,y:y,z:z,s:speech,sp:space,t:t,o:orientation,spa:spa,it:this._appData.activeItens,a:a,ch:this._appData.channel});
                }
                if (!this._appData.instagramUser.position){this._appData.instagramUser.position={x:0,y:0,z:0}}
                this._appData.instagramUser.position.x=x;
                this._appData.instagramUser.position.y=y;
                this._appData.instagramUser.position.z=z;

                if (this._appData.instagramUser.space!=space){
                  this._appData.instagramUser.space=space;
                  if ( this.locationWorker){
                    this.locationWorker.postMessage({type:'monitorPosition',room:this._appData.room,uid:this._appData.instagramUser.uid,space:space,channel:this._appData.channel}); // Send data to our worker.

                  }
                }

              }

            }
            if (this._appData.instagramUser.positionDoor){
              delete this._appData.instagramUser.position
              delete this._appData.instagramUser.positionDoor
              this._companyService.updateFirebaseUserProfile(this._appData.instagramUser)

            }

            break;
          }
          case 'writable':{
            let param=e.data.param;
            param.id=e.data.id
            this._appData.param=param;
            this._companyService.openExternalLink(param.link,true)
            break;
          }
          case 'roomItem':{
            let param=e.data.param;
            param.id=e.data.id
            this._appData.param=param;
            let distance=e.data.param.distance
            //pre-requisites
            if (distance>600){
              Swal.fire({title:this.translate.instant('EVENT_COMPONENT_46'),text:this.translate.instant('EVENT_COMPONENT_47')})
              return;
            }
            $('#RoomItemModal').modal('show')
            $('#RoomItemModalClick').click();
            $('#RoomItemModal').on('hidden.bs.modal',  () =>{
              // do something…
              $('#RoomItemModalUnload').click()
              this._appData.focusIframe=""
            })
            break;
          }
          case 'gotoLink':{
            //openning door
            if (e.data.space){
              this._appData.instagramUser.positionDoor={
                room:e.data.room,space:e.data.space}
              this._companyService.updateProfile(this._appData.instagramUser).then(v=>{
                window.location.href=e.data.link;

              })

            }else{
              window.location.href=e.data.link;

            }
            break
          }
          case 'openLink':{
            let param=e.data.param;
            let link=param.link;
            let reload=param.reload;
            let title=this.translate.instant('EVENT_COMPONENT_40')
            let description=this.translate.instant('EVENT_COMPONENT_41')
            if (e.data.name){
              title=this.translate.instant('EVENT_COMPONENT_42')+e.data.name;
              description=this.translate.instant('EVENT_COMPONENT_43')+e.data.name+this.translate.instant('EVENT_COMPONENT_44')
            }

            if (!this._appData.clicking){

              Swal.fire({
                title:title,
                showCloseButton: true,
                text: description,
                confirmButtonText: this.translate.instant("YES"),
                preConfirm: () => {
                  if (reload){
                    window.location.href=param.link;
                    this._appData.clicking=false;

                  }
                  else{
                    this._appData.clicking=false;
                    this._companyService.openExternalLink(param.link,true)
                  }
                },
                willClose: () => {
                    this._appData.clicking=false;
                }
              }).then((result) => {
                if (result.isConfirmed) {
                  // Trata a confirmação, se necessário
                }
              }).finally(() => {
                    this._appData.clicking=false;
              });
                          }
            this._appData.clicking=true;

            break;

          }
          case 'registerClick':{
            if (e.data.id){
              let date=new Date();
              let time=date.getTime()
              this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid).update({ck:e.data.id,t:time}).then(v=>{})
              setTimeout(v=>{
                this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid).update({ck:'',t:(time+3000)}).then(v=>{})
              },3000) 
            }
            break;
          }
          case 'equipReadyPlayer':{
            let assetId=e.data.assetId;
            this._companyService.equipReadyPlayer(this._appData.instagramUser,assetId)
            break
          }
          case 'reload':{
            let param=e.data.param;
            let link=param.link;
            let room=param.room
            if (!room){
              Swal.fire({
                title:'Ir para '+param.name,
                showCloseButton: true,
                text: "Você aceita ir para "+param.name+"?",
                confirmButtonText: this.translate.instant("YES"),
                preConfirm: () => {
                  window.location.href=param.link;
                }
              });
            }
            else{
              let count=0;
              let message=''

              this._companyService.updateConferenceUsers({id:room}).get().then((snap)=>{
                let us=snap.data(); //objects correspond to users;
                let names='';
                for (let key in us){
                  count++;
                  names=names+us[key].name+', '
                }
                if (count==0){
                  names=' sala vazia'
                }

                this._companyService.getRoom(room).get().then(val=>{
                  let roomData=val.data()

                  let islocked;
                  $('#youtubeReload').click();
                  if (  this._appData.room.meetingName ){
                    message='Nesta sala está sendo feita a reunião: '+roomData.meetingName+'. Estão participando: '+names                  }

                  if (roomData.locked){
                    islocked='trancada '

                  }
                  else{
                    islocked='destrancada '
                  }
                  if (roomData.key){
                    let key=roomData.key;
                    let hasKey=this.checkKey(key)
                    if (hasKey){
                      let date=new Date()
                      let time=date.getTime();
                      let swalObj={
                        title:param.name+' está '+islocked,
                        text:message+ "Você possui a chave. O que deseja fazer?",
                        showCloseButton: true,
                        confirmButtonText: 'Entrar'
                        }
                        if (hasKey && roomData.locked){
                          swalObj['footer']='<button id="lock-action'+time+'">destrancar</button>'
                        }
                        if (hasKey && !roomData.locked){
                          swalObj['footer']='<button id="lock-action'+time+'">trancar</button>'
                        }

                      Swal.fire(swalObj).then((result) =>{
                        if (result.value) {
                          window.location.href=param.link;
                        }
                      })
                      $(document).on('click', '#lock-action'+time, ()=> {
                        roomData.locked=!roomData.locked;
                        let l
                        if (roomData.locked){
                          l='trancou '
                        }
                        else{
                          l='destrancou '
                        }
                        this._companyService.getRoom(roomData.id).set(roomData)
                        Swal.fire({title:this.translate.instant('SUCCESS'),text:'Você '+l+param.name+'.'})

                      });
                    }
                    else{
                      Swal.fire({
                        title:param.name+' trancada',
                        showCloseButton: true,
                        text: message+ " Essa sala está trancada você pode entrar mas terá de pedir permissão para participar. Deseja entrar?",
                        confirmButtonText: this.translate.instant("YES"),
                        preConfirm: () => {
                          window.location.href=param.link;
                        }
                      });
                    }
                  }
                  else{
                    Swal.fire({
                      title:'Ir para '+param.name,
                      showCloseButton: true,
                      text: "Você aceita ir para "+param.name+"?",
                      confirmButtonText: this.translate.instant("YES"),
                      preConfirm: () => {
                        window.location.href=param.link;
                      }
                    });
                  }
                })
              });


            }
            break;
          }
          case 'localConference':{
            let param=e.data.param;
            let name=param.name;
            let room={jitsiServer:this._appData.room.jitsiServer,id:name+this._appData.room.id}
            Swal.fire({
              title:this.translate.instant('EVENT_COMPONENT_26'),
              showCloseButton: true,
              text:this.translate.instant('EVENT_COMPONENT_27')+param.name,
              confirmButtonText: this.translate.instant("YES"),
              preConfirm: () => {
                this.sendIframeMessage({
                  kind:'startVideoCall',
                  params:room,
                  type:'localConference'
                });
                let timerInterval
                Swal.fire({
                  title: this.translate.instant('EVENT_COMPONENT_28'),
                  html: this.translate.instant('EVENT_COMPONENT_29')+param.name+this.translate.instant('EVENT_COMPONENT_30'),
                  timer: 10000,
                  timerProgressBar: true,
                  didOpen: () => {
                    Swal.showLoading()
                    const b = Swal.getHtmlContainer().querySelector('b')
                    timerInterval = setInterval(() => {
                      b.textContent = Swal.getTimerLeft()
                    }, 100)
                  },
                  willClose: () => {
                    clearInterval(timerInterval)
                  }
                }).then((result) => {
                  /* Read more about handling dismissals below */
                  if (result.dismiss === Swal.DismissReason.timer) {
                  }
                })
              }
            })

              break
          }
          case 'videoUpdate':{
            this.event.video=(e.data.video);
            this._appData.room.video=e.data.video;
            $("#youtubeReload").click();
            break;
          }
          case 'muteYoutube':{
            $('#fixYoutubeMute').click();
            break;
          }
          case 'npcTalk':{
            let param=(e.data.param);
            this._appData.npc=param;
            let date=new Date();
            let time=date.getTime()
            if (e.data.id){
              this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid).update({ck:e.data.id,t:time}).then(v=>{})
              setTimeout(v=>{
                this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid).update({ck:'',t:(time+3000)}).then(v=>{})
              },3000)

            }
            $("#npcReload").click();
            break;
          }
          case 'vendorTalk':{
            let param=(e.data.param);
            this._appData.npc=param;
            $("#vendorModalClick").click();
            break;
          }

          case 'writ':{
            let writParam=(e.data.param);
            let id=null;
            let writ=null;
            if (writParam.type=='writ'){//give a writ to the user
              id='writ'
              writ=writParam.writ
            }
            else if (writParam.type=='association'){//user triggered the writ but not the final test
              id='association'
              writ=writParam.writAssociation;
            }
            else{//user is testing if the writ is complete
              id='test'
              writ=writParam.writTest;
            }
            this.doWrit(id,writ)
            break;

          }
          case 'itemWrit':{
            let writ=(e.data.param);
            this.doWrit(writ.kind,writ)
            break;

          }

          case "cameraFix":{
            Swal.fire({
              title:this.translate.instant('EVENT_COMPONENT_18'),
              text:this.translate.instant('EVENT_COMPONENT_19'),
              confirmButtonText: "OK",
              cancelButtonText:this.translate.instant('NO'),
              showCloseButton: true,
              showCancelButton: true,
              focusConfirm: false,
              }).then((result) => {
                if (result.dismiss=='backdrop') {}
                else if (result.dismiss=='close') {}
                else if (result.dismiss=='cancel'){}
                else{
                  let domain=window.location.origin
                  window.location.href=domain+"/welcome?event="+this._appData.event.id+'&room='+this._appData.room.id;
                }
              })
                  break;
          }
          case 'needLogin':{
            $('#registerSocialModal').modal('show')
            this._appData.tiping=true;
            break;
          }
          case 'dominantSpeakerChanged':{
            $('#youtubeMute').click();
            break

          }
          case 'clickedMe':{
            let menu=$('#userMenu')
            if (menu.css('display')=='none'){
              menu.css('display','inline')
              $('#btn-chamada').click();
            }
            else{
              $('#btn-chamada').click();
              setTimeout(()=>{
                menu.css('display','none')
              },1000)

            }
            break;
          }
          case 'askToTalk':{
            //receive the data from the user requesting to talk with me
            let uid=e.data.uid;

            let full_name=e.data.full_name;
            let profile_picture=e.data.profile_picture;
            let x=e.data.x;
            let y=e.data.y;
            let type=e.data.type;
            this._appData.friendOnEvent={
              uid:uid,
              full_name:full_name,
              profile_picture:profile_picture
            }
            $('#userInteractionModal').modal('show');
            $('#userInteractionModalClick').click();
            break;
          }
        }
	    });
    }

    public share(){
      this.sendIframeMessage({kind:'share'});
    }
    public gotoFashion(){
      let domain=window.location.origin
      window.location.replace(domain+"/avatar?uid="+this._appData.instagramUser.uid+"&room="+this._appData.room.id);

    }
    public gotoPista(){
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.sendIframeMessage({kind:'chatControl',value:0});
  }
  public testWrit(writ){
    let canContinue=null

    switch(writ.kind){
      case 'equip':{
        writ.itens.forEach(it=>{
          let hasIt=false
          if (this._appData.instagramUser.avatarConfig){
            let itens=this._appData.instagramUser.avatarConfig.configurations.filter(eq=>{
              return ((eq.objectId==it));
            })
            if (itens.length==0){
              canContinue= writ.fail;
             }
          }
          else{
            canContinue= writ.fail;
          }
        })
      }
    }
    return canContinue;
  }
  public leave(){
      this._appData.instagramUser=null;
      let company=new CompanyBean();
      let event=new EventBean();
      event.company=company;
      this._appData.event=event;
      this._appData.page=''
      localStorage.clear();
      $("#profileModal").modal('hide');
      window.location.href = "https://liveplanet.com.br";
  }


  public gotoBag(){
    if (isNaN(this._appData.instagramUser.uid)){
      this._appData.object=null;
      $('#jitsi-control-tutorial').click();
      $('#containerModal').modal('show')
/*      $('#containerModal').draggable({
        handle: ".modal-header"
      });*/
      $('#containerModalClick').click();
    }
    else{
      Swal.fire(this.translate.instant('EVENT_COMPONENT_16'),this.translate.instant('EVENT_COMPONENT_17'))
    }
  }
  public openVideoConf(){
    this._appData.jitsiOn=    !this._appData.jitsiOn
    this.sendIframeMessage({
      kind:'toggleJitsi',
      params:this._appData.jitsiOn
    });
  }

  public gotoMap(){
    if (this._appData.room.map){
      Swal.fire({title:this.translate.instant('EVENT_COMPONENT_20'),
      text:this.translate.instant('EVENT_COMPONENT_21'),
      confirmButtonText:this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('CANCEL'),
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      }).then((result) => {
        if (result.dismiss=='backdrop') {}
        else if (result.dismiss=='close') {}
        else if (result.dismiss=='cancel'){
        }
        else{
          if (this._appData.room.menuConfig && this._appData.room.menuConfig.noMap.length>0){
            let domain=this._appData.room.menuConfig.noMap
            window.location.href = domain
          }
          else{
            let domain=window.location.origin
            window.location.href = domain+"/map/"+this._appData.event.id+"?lat="+this._appData.room.map.lat+"&lng="+this._appData.room.map.lng;
          }
        }
      })
    }
    else{
      Swal.fire({title:this.translate.instant('EVENT_COMPONENT_22'),text:this.translate.instant('EVENT_COMPONENT_23')})
    }
  }

public checkKey(needKey){
  if (needKey==this._appData.instagramUser.uid){
    return true;
  }
  else{
    let filtered=this._appData.userEventContainer.filter(val=>{
      if (val.param){
        if (val.param.door){
          return val.param.door==needKey
        }
        else if (val.param.room == needKey){
          return true;
        }
        else{
          return false;
        }
      }
      else{
        return false;
      }
    })
    if (filtered[0]){
      return true;
    }
  }
  return false;
}


public lock(){
  let door=this.door
  let locked=this.door.param.locked;
  let hasKey=this.door.hasKey;
  if (locked){
    locked=false;
  }
  else{
    locked=true
  }
  this.door.param.locked=locked;
  if (!hasKey){
    Swal.fire({title:this.translate.instant('EVENT_COMPONENT_24'),text:this.translate.instant('EVENT_COMPONENT_25')})
    return;
  }
  //solve on memory
  this._appData.room.roomObjects[this.door.idx].param.locked=locked
  //update database
  this._companyService.updateRoom(this._appData.room)
  //update game
  this.sendIframeMessage({
    kind:'updateObjectParams',
    param:{objectId:this._appData.room.roomObjects[this.door.idx].objectId,param:this.door.param}
  });
  Swal.close()
}

  public isNumber(n){
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
 }
 private getRoomItems(){
  if (this.itensOnRoomFeed){
    this.itensOnRoomFeed();
  }
  this.itensOnRoomFeed=this._companyService.getUserRoomItemRef(this._appData.room.id).onSnapshot((querySnapshot) => {
    querySnapshot.docChanges().forEach((change) => {
      let obj=new ItemBean();
      obj.parse(change.doc.data());

      if (change.type === "added") {
        this.sendIframeMessage({
          kind:'addItem',
          item:obj.toDB()
        })
      }
      if (change.type === "modified") {
        this.sendIframeMessage({
          kind:'updateItem',
          item:obj.toDB()
        })
      }
      if (change.type === "removed") {
        this.sendIframeMessage({
          kind:'removeItem',
          item:obj.toDB()
        })
      }
    });
  });

}
  private getUserPositions(){



    try{
      if (!this.locationWorker && this._appData.room.multiplayer>0){
        this.locationWorker = new Worker('/assets/js/workers/locationWorker.js');
        this.locationWorker.addEventListener('message', (e)=> {
          let obj=e.data;
          if (obj.type === "added") {
            obj.room=this._appData.room.id
            if (obj.uid!=this._appData.instagramUser.uid){
              let date=new Date();
              let time=date.getTime();
              let normalDif=time-obj.t
              if (normalDif<0){
                normalDif=time*10-obj.t
              }
              if (normalDif>60000){
                this._companyService.getUserRoomPosition(obj.room).doc(obj.uid).update({a:-1})
                setTimeout(v=>{
                  this._companyService.getUserRoomPosition(obj.room).doc(obj.uid).get().then(us=>{
                    let user=us.data();
                    if (user.a<0){
                      this._companyService.getUserRoomPosition(obj.room).doc(obj.uid).delete();
                    }
                  })

                },60000)
              }
            }
            if (isNaN(obj.uid)){
              //logged
              let onList=this.userList.filter(v=>{
                return v.uid==obj.uid
              })
              if (onList.length==0){
                this._companyService.getUserByUid(obj.uid).then((val)=>{
                  let data=val.data();
                  data.position=obj;
                  data.positionDoor=null;
                  this.userList.push(data);
                  this.sendIframeMessage({
                    kind:'addUser',
                    user:data
                  })
                  console.log('added')

                })

              }

            }
            else{
              //not logged
              let data={
                uid:obj.uid,
                full_name:this.translate.instant('EVENT_COMPONENT_16')+obj.uid,
                position:obj
              }
              this.userList.push(data);
              this.sendIframeMessage({
                kind:'addUser',
                user:data
              })
              console.log('adding')


            }
          }
          if (obj.type === "modified") {
            this.sendIframeMessage({
              kind:'updateUser',
              user:obj
            })
            for (let i=0;i<this.userList.length;i++){
              if (this.userList[i].uid==obj.uid){
                this.userList[i].position=obj;
              }
            }
            if (obj.uid==this._appData.instagramUser.uid){
              if (obj.a==-1){
                let date=new Date();
                let time=date.getTime();
                this._companyService.getUserRoomPosition(this._appData.room.id).doc(obj.uid).update({a:15,t:time});
              }
            }
          }
          if (obj.type === "removed") {
            this.sendIframeMessage({
              kind:'removeUser',
              user:obj
            })
            this.userList=this.userList.filter((v)=>{
              return v.uid!=obj.uid;
            })
          }




        }, false);
        let myspace=0;
        this.locationWorker.postMessage({type:'monitorPosition',room:this._appData.room,uid:this._appData.instagramUser.uid,space:this._appData.room.defaultSpace ? this._appData.room.defaultSpace : 0,channel:this._appData.channel}); // Send data to our worker.
        document.addEventListener("visibilitychange", (event) => {
          this.garanteeFullScreen()
          if (document.visibilityState == "visible") {
            //do something
            let date=new Date();
            let time=date.getTime()
            if (this.muted){
              this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid.toString()).update({a:21,t:time})
            }
            else{
              this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid.toString()).update({a:0,t:time})
            }
            this._companyService.getUserRoomPosition(this._appData.room.id).where("spa","array-contains",this._appData.instagramUser.space).get().then(us=>{
              let date=new Date();
              let time=date.getTime()
              us.forEach(u=>{
                let obj=u.data();
                  obj['f']=true;
                  if (obj.uid!=this._appData.instagramUser.uid){
                    this.sendIframeMessage({
                      kind:'updateUser',
                      user:obj
                    })
                  }

              })

            })

          } else {
            //do something
            this._companyService.getUserRoomPosition(this._appData.room.id).doc(this._appData.instagramUser.uid.toString()).update({a:15})
          }
        });
      }
    }
    catch (err){}







//    this._companyService.test3dUserQuantity(20,this._appData.room.id)


//    this._companyService.test3dUserQuantity(50,this._appData.room.id)

  }


  ///PHOTO EDIT
  public selectPhotoBackground(){
    if (this._appData.room){
      if (this._appData.room.backgroundPhoto && this._appData.room.backgroundPhoto.length>0){
        let myid=this._appData.instagramUser.space;
        this._appData.spaceToEdit=myid
        this.choosePhotoImage();
      }
      if (this._appData.room.background2d && this._appData.room.background2d.length>0){
        let idx=this._appData.spaceToEdit;
        let myid=idx;
        this.background2dForm = this.fb.group({
          x : this._appData.room.background2d[idx].x,
          y: this._appData.room.background2d[idx].y
        });
      }

    }
  }
  public update2dBackground(){
    let x=this.background2dForm.controls['x'].value;
    let y=this.background2dForm.controls['y'].value;
    this._appData.room.background2d[this._appData.spaceToEdit].y=y;
    this._appData.room.background2d[this._appData.spaceToEdit].x=x;
    this.sendIframeMessage({kind:"updateBackground",data:{x:x,y:y,idx:Number(this._appData.spaceToEdit)}});

   }
   public save2dBackground(){
    let x=this.background2dForm.controls['x'].value;
    let y=this.background2dForm.controls['y'].value;
    this._appData.room.background2d[this._appData.spaceToEdit].y=y;
    this._appData.room.background2d[this._appData.spaceToEdit].x=x;
    this._companyService.updateRoom(this._appData.room);
    Swal.fire({title:'Sucesso',text:'Sala atualizada.'})
   }

   public saveBackground(){
    if (this._appData.room.background2d && this._appData.room.background2d.length>0){
      this.save2dBackground();
    }
    else{
      this.savePhotoBackground();
    }
    this.sendIframeMessage({kind:"updateBackground",data:{x:0,y:0,idx:null}});

   }
   public select2dIcon(medias,transition){
    let idx=0;
    let id=0
    this._appData.room.backgroundPhoto.forEach(v=>{
      if (v.id==this._appData.spaceToEdit){
        idx=id;
      }
      id++;
    })
    this._appData.room.backgroundPhoto[idx].transitions[transition].media=medias.id;
    this.updateBackgroundTransition(transition)
  }
  public choosePhotoImage(){
    let idx=0
    let id=0
    this._appData.room.backgroundPhoto.forEach(v=>{
      if (v.id==this._appData.spaceToEdit){
        idx=id
      }
      id++;
    })

    let trans=[]
    if (this._appData.room.backgroundPhoto[idx].transitions){
      this._appData.room.backgroundPhoto[idx].transitions.forEach(v=>{
        trans.push(this.fb.group({
          x :v.x,
          y:v.y,
          z :v.z,
          name: v.name ? v.name : '',
          rx:v.rx ? v.rx : 0,
          ry:v.ry ? v.ry : 0,
          rz:v.rz ? v.rz : 0,
          sx:v.sx ? v.sx : 1,
          sy:v.sy ? v.sy : 1,
          sz:v.sz ? v.sz : 1,
          nextAngle:v.nextAngle?v.nextAngle : 0,
          idx:v.idx,
          d:v.d
        }))
      })

    }
    else{
      this._appData.room.backgroundPhoto.transitions=[]
    }

    this.backgroundPhotoForm = this.fb.group({
      x : this._appData.room.backgroundPhoto[idx].x,
      y: this._appData.room.backgroundPhoto[idx].y,
      ry : this._appData.room.backgroundPhoto[idx].r,
      raio: this._appData.room.backgroundPhoto[idx].ra,
    });
    this.backgroundPhotoForm['transitions']=trans;
   }
   
   public processAndroidStyle(){
    return;
    if (this._appData.android && !this._appData.room.ar){
      document.getElementById('mhtml').style.transform='rotate(-90deg)'
      document.getElementById('mhtml').style['transform-origin']='left top'
      document.getElementById('mhtml').style.width='100vh'
      document.getElementById('mhtml').style.height='100vw'
      document.getElementById('mhtml').style['overflow-x']='hidden'
      document.getElementById('mhtml').style.position='absolute'
      document.getElementById('mhtml').style.top='100%'
      document.getElementById('mhtml').style.left='0'
      var iframe = document.getElementById('gameFrame');
      iframe.style.height='calc(100vw - 0px)'
      iframe.style.width='calc(100vh - 0px)'

      let popup=document.getElementById('iframeModal')
      popup.style.width='30vh'
      popup.style.left='30vh'
      popup.style.height='80vw'
      popup.style.top='10vw'
      let popupmodalImage=document.getElementById('modalImage')
      popupmodalImage.style.width='40vh'
      popupmodalImage.style.height='30vw'
      popupmodalImage.style.maxWidth='60vw'
      document.getElementById('mensagem_entrada').style.fontSize='14px'
    }
  }
  public removeAndroidStyle(){
    if (this._appData.android && !this._appData.room.ar){
        document.getElementById('mhtml').style.transform='rotate(0deg)'
        document.getElementById('mhtml').style['transform-origin']=''
        document.getElementById('mhtml').style.width=''
        document.getElementById('mhtml').style.height=''
        document.getElementById('mhtml').style['overflow-x']='hidden'
        document.getElementById('mhtml').style.position=''
        document.getElementById('mhtml').style.top=''
        document.getElementById('mhtml').style.left=''
        var iframe = document.getElementById('gameFrame');
        iframe.style.height='calc(100vh - 0px)'
        iframe.style.width='calc(100vw - 0px)'


      let popup=document.getElementById('iframeModal')
      popup.style.width='30vw'
      popup.style.left='30vw'
      popup.style.height='30vh'
      popup.style.top='30vh'

     let popupmodalImage=document.getElementById('modalImage')
      popupmodalImage.style.width='40vw'
 
    }
  }
  public updatePhotoBackground(){
    let idx=0;
    let id=0
    this._appData.room.backgroundPhoto.forEach(v=>{
      if (v.id==this._appData.spaceToEdit){
        idx=id;
      }
      id++;
    })

    let x=this.backgroundPhotoForm.controls['x'].value;
    let y=this.backgroundPhotoForm.controls['y'].value;
    let ry=this.backgroundPhotoForm.controls['ry'].value;
    let raio=this.backgroundPhotoForm.controls['raio'].value;
    this._appData.room.backgroundPhoto[idx].y=y;
    this._appData.room.backgroundPhoto[idx].x=x;
    this._appData.room.backgroundPhoto[idx].rotate={x:0,y:ry,z:0};
    this._appData.room.backgroundPhoto[idx].ra=raio;
    this.sendIframeMessage({kind:"updatePhotoBackground",data:this._appData.room.backgroundPhoto[this._appData.spaceToEdit],idx:this._appData.spaceToEdit});

  }
   public savePhotoBackground(){
    let idx=0;
    let id=0
    this._appData.room.backgroundPhoto.forEach(v=>{
      if (v.id==this._appData.spaceToEdit){
        idx=id;
      }
      id++;
    })

    let x=this.backgroundPhotoForm.controls['x'].value;
    let y=this.backgroundPhotoForm.controls['y'].value;
    let ry=this.backgroundPhotoForm.controls['ry'].value;
    let raio=this.backgroundPhotoForm.controls['raio'].value;
    this._appData.room.backgroundPhoto[idx].y=y;
    this._appData.room.backgroundPhoto[idx].x=x;
    this._appData.room.backgroundPhoto[idx].rotate={x:0,y:ry,z:0};
    this._appData.room.backgroundPhoto[idx].ra=raio;
    this._companyService.updateRoom(this._appData.room);
    Swal.fire({title:'Sucesso',text:'Sala atualizada.'})
    this._appData.spaceToEdit=null;
   }

   public getIconMedia(media){
    let url= media['i2d'];
    if (!url){
      url=media['i3d']
    }
    return url;
   }
   public addTransition(){
    this.backgroundPhotoForm['transitions'].push(this.fb.group({
      x :0,
      y:0,
      z :0,
      nextAngle:null,
      r:0,
      idx:0
      }))
      if (!this._appData.room.backgroundPhoto[this._appData.spaceToEdit]['transitions']){
        this._appData.room.backgroundPhoto[this._appData.spaceToEdit]['transitions']=[{z:0,x:0,y:0,idx:0}]
      }
      else{
        this._appData.room.backgroundPhoto[this._appData.spaceToEdit]['transitions'].push({z:0,x:0,y:0,idx:0})
      }

  }
   public updateBackgroundTransition(j){
    let x=0;
    let y=0;
    let z=0;
    let rx=0;
    let ry=0;
    let rz=0;
    let sx=0;
    let sy=0;
    let sz=0;

    
    let r=0
    let idx=0;

    let nextAngle=null

    let iddx=0;
    let id=0
    this._appData.room.backgroundPhoto.forEach(v=>{
      if (v.id==this._appData.spaceToEdit){
        iddx=id;
      }
      id++;
    })

      let name=this.backgroundPhotoForm['transitions'][j].controls['name'].value;

      x=this.backgroundPhotoForm['transitions'][j].controls['x'].value;
      y=this.backgroundPhotoForm['transitions'][j].controls['y'].value;
      z=this.backgroundPhotoForm['transitions'][j].controls['z'].value;

      rx=this.backgroundPhotoForm['transitions'][j].controls['rx'].value;
      ry=this.backgroundPhotoForm['transitions'][j].controls['ry'].value;
      rz=this.backgroundPhotoForm['transitions'][j].controls['rz'].value;

      sx=this.backgroundPhotoForm['transitions'][j].controls['sx'].value;
      sy=this.backgroundPhotoForm['transitions'][j].controls['sy'].value;
      sz=this.backgroundPhotoForm['transitions'][j].controls['sz'].value;

      nextAngle=this.backgroundPhotoForm['transitions'][j].controls['nextAngle'].value!=0?this.backgroundPhotoForm['transitions'][j].controls['nextAngle'].value:null;


      idx=this.backgroundPhotoForm['transitions'][j].controls['idx'].value;



      this._appData.room.backgroundPhoto[iddx].transitions[j].x=x
      this._appData.room.backgroundPhoto[iddx].transitions[j].y=y
      this._appData.room.backgroundPhoto[iddx].transitions[j].z=z


      this._appData.room.backgroundPhoto[iddx].transitions[j].rx=rx
      this._appData.room.backgroundPhoto[iddx].transitions[j].ry=ry
      this._appData.room.backgroundPhoto[iddx].transitions[j].rz=rz

      this._appData.room.backgroundPhoto[iddx].transitions[j].sx=sx
      this._appData.room.backgroundPhoto[iddx].transitions[j].sy=sy
      this._appData.room.backgroundPhoto[iddx].transitions[j].sz=sz

      this._appData.room.backgroundPhoto[iddx].transitions[j].idx=idx

      this._appData.room.backgroundPhoto[iddx].transitions[j].name=name

      if (nextAngle){
        this._appData.room.backgroundPhoto[iddx].transitions[j].nextAngle=nextAngle
      }

      this._companyService.updateRoom( this._appData.room)
      this.sendIframeMessage({kind:"updatePhotoBackground",data:this._appData.room.backgroundPhoto[iddx],idx:this._appData.spaceToEdit});
  }

}





// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/event.component.ts